(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article_refonte"] && !Shopify.designMode) return;
  try {
    
  /* Genere le sommaire a partir des H2 presents dans article.content (texte
     riche saisi par l'auteur, jamais connu a l'avance). Chaque H2 recoit un
     id (slug base sur son texte) et un lien correspondant est ajoute dans
     [data-toc-links]. Le bloc entier reste cache (attribut hidden) tant
     qu'aucun H2 n'est trouve, pour ne jamais afficher un sommaire vide sur
     un article sans sous-titres. */
  document.addEventListener('DOMContentLoaded', function () {
    var source = document.querySelector('[data-toc-source]');
    var wrapper = document.querySelector('[data-toc-wrapper]');
    var linksContainer = document.querySelector('[data-toc-links]');
    if (!source || !wrapper || !linksContainer) return;

    /* Anciens calculateurs restes dans le texte (ex. dose de collagene) : leur
       <style> vise des elements nus (button, label...) et repeint le bouton du
       menu et la FAQ en rouge ; leurs scripts sont supprimes par Shopify, donc
       le calculateur ne marche plus. S'il n'a pas ete remplace par un
       calculateur du theme (data-al-calc-host), on retire le bloc et son style. */
    var motifNu = /(^|[\s,}])(button|label|select|input|h[1-6]|table|form)\s*(\[[^\]]*\])?\s*\{/;
    source.querySelectorAll('style').forEach(function (st) {
      if (motifNu.test(st.textContent || '')) st.remove();
    });
    if (!document.querySelector('[data-al-calc-host]')) {
      source.querySelectorAll('.calculator-container, .cal-calculator-container, .calculator').forEach(function (el) { el.remove(); });
    }

    var headings = source.querySelectorAll('h2');
    if (!headings.length) return;

    var usedIds = {};
    headings.forEach(function (heading) {
      var base = heading.textContent
        .trim()
        .toLowerCase()
        .normalize('NFD').replace(new RegExp('[̀-ͯ]', 'g'), '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '') || 'section';
      var id = base;
      var count = 1;
      while (usedIds[id]) {
        count += 1;
        id = base + '-' + count;
      }
      usedIds[id] = true;
      heading.id = id;

      var link = document.createElement('a');
      link.href = '#' + id;
      link.className = 'article_toc-link w-inline-block';
      link.innerHTML = '<div class="article_toc-link-icon"></div><div>' + heading.textContent + '</div>';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(id);
        if (!target) return;
        var offset = 96;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
      linksContainer.appendChild(link);
    });

    wrapper.hidden = false;

    /* Sur mobile (colonne de gauche masquee), le sommaire passe dans un
       accordeon en tete du contenu, comme sur le site Mera. */
    var mobile = document.querySelector('[data-toc-mobile]');
    var mobileLinks = document.querySelector('[data-toc-links-mobile]');
    if (mobile && mobileLinks) {
      linksContainer.querySelectorAll('a').forEach(function (a) {
        var copy = a.cloneNode(true);
        copy.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.querySelector(copy.getAttribute('href'));
          fermerSommaire();
          if (!target) return;
          window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 96, behavior: 'smooth' });
        });
        mobileLinks.appendChild(copy);
      });
      mobile.hidden = false;

      /* Accordeon = meme composant que la FAQ (data-accordion-*, anime par
         snippets/utility_scripts.liquid). */
      var fermerSommaire = function () {
        var item = mobile.querySelector('[data-accordion-item]');
        if (item && item.classList.contains('is-open')) item.querySelector('[data-accordion-trigger]').click();
      };
    }

    /* Appels de source [n] : un clic ouvre une petite bulle avec le titre de la source,
       sans faire descendre la page. Le lien externe s'ouvre dans un nouvel onglet. */
    var bulle = null, refOuvert = null;
    function fermerBulle() {
      if (bulle) { bulle.remove(); bulle = null; }
      if (refOuvert) { refOuvert.removeAttribute('aria-expanded'); refOuvert = null; }
    }
    document.addEventListener('click', function (e) {
      var ref = e.target.closest && e.target.closest('sup a[href^="#source-"]');
      if (!ref) { if (bulle && !bulle.contains(e.target)) fermerBulle(); return; }
      e.preventDefault();
      if (refOuvert === ref) { fermerBulle(); return; }
      fermerBulle();
      var li = document.querySelector(ref.getAttribute('href'));
      if (!li) return;
      bulle = document.createElement('div');
      bulle.className = 'refonte_src-bulle';
      bulle.setAttribute('role', 'note');
      var num = document.createElement('span');
      num.className = 'refonte_src-bulle-num';
      num.textContent = 'Source ' + ref.textContent.trim();
      bulle.appendChild(num);
      var lien = li.querySelector('a');
      if (lien) { var a = lien.cloneNode(true); a.target = '_blank'; a.rel = 'noopener'; bulle.appendChild(a); }
      else { bulle.appendChild(document.createTextNode(li.textContent.trim())); }
      document.body.appendChild(bulle);
      var r = ref.getBoundingClientRect(), w = bulle.offsetWidth, h = bulle.offsetHeight;
      var left = Math.min(Math.max(16, r.left + r.width / 2 - w / 2), document.documentElement.clientWidth - w - 16);
      var top = r.top - h - 8 > 90 ? r.top - h - 8 : r.bottom + 8;
      bulle.style.left = (left + window.scrollX) + 'px';
      bulle.style.top = (top + window.scrollY) + 'px';
      ref.setAttribute('aria-expanded', 'true');
      refOuvert = ref;
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermerBulle(); });
    window.addEventListener('resize', fermerBulle);

    /* Partage : copier le lien de l'article */
    document.querySelectorAll('[data-share-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-share-copy');
        var fini = function () { btn.classList.add('is-copied'); setTimeout(function () { btn.classList.remove('is-copied'); }, 1800); };
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(fini, fini); }
        else { var t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} t.remove(); fini(); }
      });
    });

    /* Maquette refonte : surligne dans le sommaire la partie en cours de lecture. */
    if ('IntersectionObserver' in window) {
      var links = linksContainer.querySelectorAll('a');
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id); });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      headings.forEach(function (h) { obs.observe(h); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  /* Page panier — couche AJAX.
     Duplique volontairement une partie de la logique de mini_cart.liquid
     (voir la note dans ce fichier sur le bundling par section) : quantite,
     suppression et rafraichissement du mini-panier + du compteur navbar. */
  (function () {
    /* Numero croissant attribue a chaque requete qui va re-rendre la section.
       Si des reponses reviennent dans le desordre (rafale de clics sur +/-,
       requetes concurrentes), on n'applique que la reponse de la requete la
       plus recemment envoyee -- les autres sont perimees et ignorees. */
    var requestSeq = 0;
    /* Un code peut s'appliquer au panier entier (cart_level_discount_applications)
       OU seulement a certaines lignes (ex. NEWLIFE15, limite a une collection) :
       dans ce cas Shopify ne le met que dans discount_applications / dans les
       remises de chaque ligne. On regarde les trois, sinon un code valide etait
       annonce comme « invalide ou expire ». */
    function discountCodeApplied(data, code) {
      if (!data || !code) return false;
      var wanted = code.trim().toLowerCase();
      function match(d) {
        var title = (d && (d.title || d.code || '')).toString().trim().toLowerCase();
        return title === wanted;
      }
      var lists = [data.cart_level_discount_applications, data.discount_applications];
      for (var i = 0; i < lists.length; i++) {
        if (lists[i] && lists[i].some(match)) return true;
      }
      var items = data.items || [];
      for (var j = 0; j < items.length; j++) {
        var it = items[j];
        if (it.discounts && it.discounts.some(match)) return true;
        if (it.line_level_discount_allocations && it.line_level_discount_allocations.some(function (a) {
          return match(a && a.discount_application);
        })) return true;
      }
      return false;
    }

    /* Croix -> petite roue pendant le retrait du code (le panier se re-rend
       ensuite, donc pas besoin de remettre la croix). */
    function setRemoveLoading(btn, loading) {
      if (!btn) return;
      var icon = btn.querySelector('[data-cart-discount-remove-icon]');
      var loader = btn.querySelector('[data-cart-discount-remove-loader]');
      if (icon) icon.style.display = loading ? 'none' : '';
      if (loader) loader.hidden = !loading;
    }

    /* Essai d'un code promo sans perdre ceux deja appliques (dont le code
       Joy des Active Coins). Shopify dit seulement « applicable » ou non :
       pour distinguer un code faux d'un code non cumulable, on le reessaie
       seul, puis on remet toujours les codes d'avant. Resultat : statut
       'ok' | 'cumul' | 'invalide', data = dernier cart.json (avec sections). */
    function essaiCodePromo(code, sections) {
      var bas = code.toLowerCase();
      function maj(discount) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: discount, sections: sections })
        }).then(function (r) { return r.json(); });
      }
      function codes(data) { return (data && data.discount_codes) || []; }
      function trouve(data) {
        return codes(data).filter(function (c) { return String(c.code).toLowerCase() === bas; })[0];
      }
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (panier) {
          var avant = codes(panier)
            .filter(function (c) { return c.applicable && String(c.code).toLowerCase() !== bas; })
            .map(function (c) { return c.code; });
          return maj(avant.concat(code).join(',')).then(function (data) {
            if (!Array.isArray(data.discount_codes)) {
              return { statut: discountCodeApplied(data, code) ? 'ok' : 'invalide', data: data, avant: avant };
            }
            var nouveau = trouve(data);
            var perdus = codes(data).filter(function (c) { return !c.applicable && String(c.code).toLowerCase() !== bas; });
            if (nouveau && nouveau.applicable && !perdus.length) return { statut: 'ok', data: data, avant: avant };
            var seul = avant.length
              ? maj(code).then(function (d) { var n = trouve(d); return !!(n && n.applicable); })
              : Promise.resolve(false);
            return seul.then(function (marcheSeul) {
              /* Non cumulable avec un code Joy (Active Coins) : le nouveau code
                 le remplace, et on REVOQUE le code Joy pour que les points
                 reviennent au client (snippets/joy_redeem.liquid). Si la
                 revocation echoue, on remet le code Joy et on previent. */
              var joyCodes = avant.filter(function (c) { return /^(joy|active)-/i.test(c); });
              if (marcheSeul && joyCodes.length && typeof window.ALJoyRevoke === 'function') {
                return window.ALJoyRevoke(joyCodes[0])
                  .then(function () { return maj(code); })
                  .then(function (d3) { return { statut: 'remplace', data: d3, avant: avant }; })
                  .catch(function () {
                    return maj(avant.join(',')).then(function (d4) { return { statut: 'cumul', data: d4, avant: avant }; });
                  });
              }
              return maj(avant.join(',')).then(function (d2) {
                return { statut: marcheSeul ? 'cumul' : 'invalide', data: d2, avant: avant };
              });
            });
          });
        });
    }

    function messageCodePromo(res) {
      if (res.statut === 'remplace') return 'Code appliqué à la place de tes Active Coins : tes points t’ont été rendus.';
      /* 'invalide' couvre aussi un code valable mais pas sur ces articles
         (ex. la whey, exclue des codes promo) : Shopify ne fait pas la difference. */
      if (res.statut !== 'cumul') return 'Code invalide, expiré ou non valable sur les articles de ton panier.';
      var joy = res.avant.some(function (c) { return /^(joy|active)-/i.test(c); /* codes Joy (prefixe « Active- » depuis septembre) */ });
      return joy
        ? 'Ce code ne se cumule pas avec tes Active Coins déjà utilisés : retire-les pour l’utiliser.'
        : 'Ce code ne se cumule pas avec le code « ' + res.avant[0] + ' » déjà appliqué : retire-le pour l’utiliser.';
    }

    function nextRequestSeq() {
      requestSeq += 1;
      return requestSeq;
    }

    function cartSection() {
      return document.querySelector('[data-cart-section]');
    }

    var cartMoneyFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
    function formatMoney(amount) {
      return cartMoneyFormatter.format(amount);
    }

    /* Retrouve la valeur numerique a partir du texte deja affiche (ex.
       "24,90 €" -> 24.9) : le HTML frais renvoye par Shopify ne porte que du
       texte formate, jamais le nombre brut, et c'est de toute facon la seule
       valeur "avant" disponible juste avant que innerHTML ne soit remplace. */
    function parseMoneyText(text) {
      if (!text) return NaN;
      var cleaned = text.replace(/[^\d,]/g, '').replace(',', '.');
      var value = parseFloat(cleaned);
      return isNaN(value) ? NaN : value;
    }

    function miniCartWrapper() {
      return document.querySelector('[data-mini-cart]');
    }

    function closeMiniCart() {
      var w = miniCartWrapper();
      if (!w) return;
      w.classList.remove('is-open');
      if (window.SiteOverlay) {
        window.SiteOverlay.close();
        window.SiteOverlay.unlockScroll();
      }
    }

    function updateBadge(count) {
      var badge = document.querySelector('[data-cart-count]');
      if (!badge) return;
      badge.textContent = count;
      badge.classList.toggle('is-empty', count === 0);
    }

    function renderCart(html) {
      var root = cartSection();
      if (!root) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
      if (!fresh) return;

      var oldTotalEl = root.querySelector('[data-cart-total-price]');
      var oldTotalValue = oldTotalEl ? parseMoneyText(oldTotalEl.textContent) : NaN;
      var oldLinePrices = {};
      root.querySelectorAll('[data-cart-item-price]').forEach(function (el) {
        var line = el.getAttribute('data-cart-line');
        var value = parseMoneyText(el.textContent);
        if (line && !isNaN(value)) oldLinePrices[line] = value;
      });

      root.innerHTML = fresh.innerHTML;

      if (window.animateNumberUpdate) {
        var totalEl = root.querySelector('[data-cart-total-price]');
        if (totalEl) {
          var newTotalValue = parseMoneyText(totalEl.textContent);
          if (!isNaN(newTotalValue)) {
            if (!isNaN(oldTotalValue)) totalEl.setAttribute('data-animate-value', oldTotalValue);
            window.animateNumberUpdate(totalEl, newTotalValue, formatMoney);
          }
        }
        root.querySelectorAll('[data-cart-item-price]').forEach(function (el) {
          var line = el.getAttribute('data-cart-line');
          var newValue = parseMoneyText(el.textContent);
          if (isNaN(newValue)) return;
          var oldValue = oldLinePrices[line];
          if (typeof oldValue === 'number') el.setAttribute('data-animate-value', oldValue);
          window.animateNumberUpdate(el, newValue, formatMoney);
        });
      }
    }

    function renderMiniCart(html) {
      var w = miniCartWrapper();
      if (!w) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mini-cart]');
      if (!fresh) return;
      w.innerHTML = fresh.innerHTML;
      w.setAttribute('data-cart-count-value', fresh.getAttribute('data-cart-count-value') || '0');
      var closeBtn = w.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeMiniCart);
    }

    function post(route, body) {
      body.sections = 'cart,mini_cart';
      return fetch(route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    function applyResponse(data, seq) {
      if (typeof seq === 'number' && seq < requestSeq) return;
      if (data && data.sections && data.sections.cart) {
        renderCart(data.sections.cart);
        if (data.sections.mini_cart) renderMiniCart(data.sections.mini_cart);
        updateBadge(data.item_count);
      } else {
        window.location.reload();
      }
    }

    /* Bascule visuelle le temps de l'appel API : le lien Supprimer cede sa
       place au loader, puis le re-rendu de la section remet tout a plat. */
    function showLineLoader(line) {
      var item = document.querySelector('[data-cart-section] [data-cart-line="' + line + '"]');
      if (!item) return;
      var deleteLink = item.querySelector('[data-cart-remove]');
      var loader = item.querySelector('[data-cart-line-loader]');
      if (deleteLink) deleteLink.hidden = true;
      if (loader) loader.hidden = false;
    }

    /* /cart/change.js ne renvoie pas le panier mais {status, description} si
       Shopify a du limiter la quantite (stock insuffisant) : le nombre
       demande n'est alors pas celui reellement applique. On construit un
       message francais a partir du nombre trouve dans la reponse plutot que
       d'afficher le texte anglais brut de Shopify. */
    function buildStockMessage(data) {
      var raw = (data && (data.description || data.message)) || '';
      var match = /(\d+)/.exec(raw);
      if (match) return 'Quantité limitée à ' + match[1] + ' (stock disponible).';
      return raw || 'Quantité limitée par le stock disponible.';
    }

    var stockMessageTimers = {};
    function showStockMessage(line, message) {
      var item = document.querySelector('[data-cart-section] [data-cart-line="' + line + '"]');
      var el = item && item.querySelector('[data-cart-stock-message]');
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
      if (stockMessageTimers[line]) clearTimeout(stockMessageTimers[line]);
      stockMessageTimers[line] = setTimeout(function () { el.hidden = true; }, 6000);
    }

    /* Pousse add_to_cart (quantite augmentee) ou remove_from_cart (quantite
       diminuee/supprimee) a partir des data-item-* portes par la ligne --
       voir assets/li_datalayer.js. Ne fait rien si la quantite n'a pas
       change (ex. clic sur "-" deja a 1). */
    function trackQuantityDelta(line, oldQuantity, newQuantity) {
      if (!window.ALDataLayer || oldQuantity === newQuantity) return;
      var item = document.querySelector('[data-cart-section] [data-cart-line="' + line + '"]');
      if (!item) return;
      var price = parseFloat(item.getAttribute('data-item-price'));
      var base = {
        item_id: item.getAttribute('data-item-id') || undefined,
        item_name: item.getAttribute('data-item-name') || undefined,
        item_brand: item.getAttribute('data-item-brand') || undefined,
        item_category: item.getAttribute('data-item-category') || undefined,
        price: isNaN(price) ? undefined : price
      };
      var variant = item.getAttribute('data-item-variant');
      if (variant) base.item_variant = variant;
      var delta = newQuantity - oldQuantity;
      if (delta > 0) {
        window.ALDataLayer.addToCart([Object.assign({}, base, { quantity: delta })]);
      } else {
        window.ALDataLayer.removeFromCart([Object.assign({}, base, { quantity: -delta })]);
      }
    }

    /* Partagee entre la saisie directe dans l'input, la suppression et les
       boutons -/+. */
    function updateQuantity(line, quantity) {
      showLineLoader(line);
      var seq = nextRequestSeq();
      post('/cart/change.js', {
        line: line,
        quantity: quantity
      }).then(function (data) {
        if (data && data.status) {
          var message = buildStockMessage(data);
          /* /cart/update.js sans rien a modifier : sert juste a relire des
             sections a jour, deja la meme astuce que pour le code promo. */
          post('/cart/update.js', {}).then(function (fresh) {
            applyResponse(fresh, seq);
            showStockMessage(line, message);
          }).catch(function () { window.location.reload(); });
          return;
        }
        applyResponse(data, seq);
      }).catch(function () { window.location.reload(); });
    }

    /* Un clic sur +/- met a jour l'affichage tout de suite, mais n'envoie la
       requete qu'apres une courte pause : sans ca, "bombarder" les boutons
       envoie une requete par clic, et une reponse en retard peut ecraser un
       etat plus recent. Une rafale de clics ne produit donc plus qu'un seul
       appel /cart/change.js, avec la quantite finale. */
    var quantityTimers = {};
    function scheduleQuantityUpdate(line, quantity) {
      showLineLoader(line);
      if (quantityTimers[line]) clearTimeout(quantityTimers[line]);
      quantityTimers[line] = setTimeout(function () {
        delete quantityTimers[line];
        updateQuantity(line, quantity);
      }, 400);
    }

    document.addEventListener('change', function (e) {
      if (!(e.target instanceof Element)) return;
      var input = e.target.closest('[data-cart-quantity]');
      if (!input || !cartSection() || !cartSection().contains(input)) return;
      var line = Number(input.getAttribute('data-cart-line'));
      var oldQuantity = Math.max(1, Math.floor(Number(input.defaultValue)) || 1);
      var quantity = Math.max(1, Math.floor(Number(input.value)) || 1);
      trackQuantityDelta(line, oldQuantity, quantity);
      updateQuantity(line, quantity);
    });

    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;

      var quantityBtn = e.target.closest('[data-cart-quantity-minus], [data-cart-quantity-plus]');
      if (quantityBtn && cartSection() && cartSection().contains(quantityBtn)) {
        var wrapper = quantityBtn.closest('.nav_cart-item-quantity-wrapper');
        var input = wrapper && wrapper.querySelector('[data-cart-quantity]');
        if (!input) return;
        var line = Number(quantityBtn.getAttribute('data-cart-line'));
        var delta = quantityBtn.hasAttribute('data-cart-quantity-minus') ? -1 : 1;
        var oldQuantity = parseInt(input.value, 10) || 1;
        var quantity = Math.max(1, oldQuantity + delta);
        if (quantity === oldQuantity) return;
        input.value = quantity;
        trackQuantityDelta(line, oldQuantity, quantity);
        scheduleQuantityUpdate(line, quantity);
        return;
      }

      var remove = e.target.closest('[data-cart-remove]');
      if (remove && cartSection() && cartSection().contains(remove)) {
        e.preventDefault();
        var line = Number(remove.getAttribute('data-cart-line'));
        var removeItem = document.querySelector('[data-cart-section] [data-cart-line="' + line + '"]');
        var removeInput = removeItem && removeItem.querySelector('[data-cart-quantity]');
        var removeOldQuantity = removeInput ? (parseInt(removeInput.value, 10) || 1) : 1;
        trackQuantityDelta(line, removeOldQuantity, 0);
        updateQuantity(line, 0);
        return;
      }

      var checkoutLink = e.target.closest('[data-cart-checkout]');
      if (checkoutLink && cartSection() && cartSection().contains(checkoutLink)) {
        if (window.ALDataLayer) {
          var checkoutItems = Array.from(document.querySelectorAll('[data-cart-section] [data-item-id]')).map(function (item) {
            var price = parseFloat(item.getAttribute('data-item-price'));
            var qtyInput = item.querySelector('[data-cart-quantity]');
            var out = {
              item_id: item.getAttribute('data-item-id') || undefined,
              item_name: item.getAttribute('data-item-name') || undefined,
              item_brand: item.getAttribute('data-item-brand') || undefined,
              item_category: item.getAttribute('data-item-category') || undefined,
              price: isNaN(price) ? undefined : price,
              quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
            };
            var variant = item.getAttribute('data-item-variant');
            if (variant) out.item_variant = variant;
            return out;
          });
          window.ALDataLayer.beginCheckout(checkoutItems);
        }
        return;
      }

      var discountRemove = e.target.closest('[data-cart-discount-remove]');
      if (discountRemove) {
        e.preventDefault();
        discountRemove.disabled = true;
        setRemoveLoading(discountRemove, true);
        /* Shopify n'a pas de route « retirer le code » : un code vide envoye
           a /cart/update.js detache la remise de la session. */
        var removeSeq = nextRequestSeq();
        post('/cart/update.js', { discount: '' })
          .then(function (data) { applyResponse(data, removeSeq); })
          .catch(function () { window.location.reload(); });
        return;
      }

      var applyBtn = e.target.closest('[data-cart-discount-apply]');
      if (applyBtn) {
        e.preventDefault();
        var input = document.querySelector('[data-cart-discount-input]');
        var code = input ? input.value.trim() : '';
        if (!code) return;
        var label = applyBtn.querySelector('[data-cart-discount-label]');
        var loader = applyBtn.querySelector('[data-cart-discount-loader]');
        if (label) label.hidden = true;
        if (loader) loader.hidden = false;
        applyBtn.disabled = true;

        /* /discount/[code] est une route Shopify native (pas une route du
           theme) : elle valide le code et l'attache a la session cote
           serveur, puis redirige. En fetch (au lieu d'une navigation), le
           navigateur suit cette redirection en arriere-plan sans changer
           l'URL affichee -- meme mecanisme que le theme Horizon. Le
           /cart/update.js qui suit ne fait rien evoluer (aucune ligne
           modifiee) : il sert juste a relire un cart.json a jour, seule
           facon de savoir si le code a reellement ete accepte. */
        var discountSeq = nextRequestSeq();
        essaiCodePromo(code, 'cart,mini_cart')
          .then(function (res) {
            var data = res.data;
            applyResponse(data, discountSeq);
            var applied = res.statut === 'ok' || res.statut === 'remplace';
            if (applied && window.ALDataLayer) {
              window.ALDataLayer.event('coupon_applied', { coupon: code, value: data.total_price ? data.total_price / 100 : undefined });
            }
            if (res.statut !== 'ok') {
              var freshError = document.querySelector('[data-cart-discount-error]');
              if (freshError) {
                freshError.textContent = messageCodePromo(res);
                freshError.hidden = false;
              }
            }
          })
          .catch(function () { window.location.reload(); });
      }
    });

    /* Le panier n'est reactualise qu'apres une pause de saisie : evite un
       appel /cart/update.js a chaque frappe. */
    var noteTimer;
    document.addEventListener('input', function (e) {
      if (!(e.target instanceof Element)) return;
      var note = e.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      }, 600);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contenu_article"] && !Shopify.designMode) return;
  try {
    
  /* Genere le sommaire a partir des H2 presents dans article.content (texte
     riche saisi par l'auteur, jamais connu a l'avance). Chaque H2 recoit un
     id (slug base sur son texte) et un lien correspondant est ajoute dans
     [data-toc-links]. Le bloc entier reste cache (attribut hidden) tant
     qu'aucun H2 n'est trouve, pour ne jamais afficher un sommaire vide sur
     un article sans sous-titres. */
  document.addEventListener('DOMContentLoaded', function () {
    var source = document.querySelector('[data-toc-source]');
    var wrapper = document.querySelector('[data-toc-wrapper]');
    var linksContainer = document.querySelector('[data-toc-links]');
    if (!source || !wrapper || !linksContainer) return;

    var headings = source.querySelectorAll('h2');
    if (!headings.length) return;

    var usedIds = {};
    headings.forEach(function (heading) {
      var base = heading.textContent
        .trim()
        .toLowerCase()
        .normalize('NFD').replace(new RegExp('[̀-ͯ]', 'g'), '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '') || 'section';
      var id = base;
      var count = 1;
      while (usedIds[id]) {
        count += 1;
        id = base + '-' + count;
      }
      usedIds[id] = true;
      heading.id = id;

      var link = document.createElement('a');
      link.href = '#' + id;
      link.className = 'article_toc-link w-inline-block';
      link.innerHTML = '<div class="article_toc-link-icon"></div><div>' + heading.textContent + '</div>';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(id);
        if (!target) return;
        var offset = 96;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
      linksContainer.appendChild(link);
    });

    wrapper.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contenu_recette"] && !Shopify.designMode) return;
  try {
    
  /* Genere le sommaire a partir des H2 presents dans article.content, meme
     script que contenu_article.liquid (voir ce fichier pour le detail du
     fonctionnement). */
  document.addEventListener('DOMContentLoaded', function () {
    var source = document.querySelector('[data-toc-source]');
    var wrapper = document.querySelector('[data-toc-wrapper]');
    var linksContainer = document.querySelector('[data-toc-links]');
    if (!source || !wrapper || !linksContainer) return;

    var headings = source.querySelectorAll('h2');
    if (!headings.length) return;

    var usedIds = {};
    headings.forEach(function (heading) {
      var base = heading.textContent
        .trim()
        .toLowerCase()
        .normalize('NFD').replace(new RegExp('[̀-ͯ]', 'g'), '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '') || 'section';
      var id = base;
      var count = 1;
      while (usedIds[id]) {
        count += 1;
        id = base + '-' + count;
      }
      usedIds[id] = true;
      heading.id = id;

      var link = document.createElement('a');
      link.href = '#' + id;
      link.className = 'article_toc-link w-inline-block';
      link.innerHTML = '<div class="article_toc-link-icon"></div><div>' + heading.textContent + '</div>';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(id);
        if (!target) return;
        var offset = 96;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
      linksContainer.appendChild(link);
    });

    wrapper.hidden = false;
  });

  /* Quickview multi-instance (un par produit lie a un ingredient/ustensile
     ou a la sidebar) + ajout panier reel -- copie identique du script de
     contenu_article.liquid (meme raisonnement que le widget Conseils
     duplique dans header_famille/header_categorie : {% javascript %} est
     bundle par section, donc rien de commun entre les deux sinon). */
  document.addEventListener('DOMContentLoaded', function () {
    var OPEN_DELAY = 100;
    var CLOSE_DELAY = 400;

    function findWrapper(id) {
      return document.querySelector('[data-quickview-wrapper][data-quickview-id="' + id + '"]');
    }

    function openQuickview(id) {
      var wrapper = findWrapper(id);
      if (!wrapper) return;
      var overlay = wrapper.querySelector('[data-quickview-overlay]');
      var component = wrapper.querySelector('[data-quickview-component]');
      wrapper.classList.add('is-open');
      setTimeout(function () {
        if (overlay) overlay.classList.add('is-open');
        if (component) component.classList.add('is-open');
        /* Galerie du quick-view jamais visible avant ouverture : Embla doit
           attendre d'avoir de vraies dimensions a mesurer (cf. window.initGallery
           dans layout/theme.liquid). Init une seule fois par instance. */
        var galleryGroup = wrapper.querySelector('[data-gallery-group]');
        if (galleryGroup && !wrapper.galleryInstance && typeof window.initGallery === 'function') {
          wrapper.galleryInstance = window.initGallery(galleryGroup);
        }
        /* Meme probleme que la galerie : les selecteurs de variantes (gout,
           poids) sont deja initialises au chargement de la page (scan global
           de layout/theme.liquid), donc mesures a tort pendant que le
           quick-view est encore en display:none. Peut y en avoir 2 (1 par
           option) ou 1 seul (produit a option unique). */
        wrapper.querySelectorAll('.embla.is-quickview-variants').forEach(function (variantEmbla) {
          if (variantEmbla.emblaApi) variantEmbla.emblaApi.reInit();
        });
      }, OPEN_DELAY);
      document.body.classList.add('no-scroll');
    }

    function closeQuickview(wrapper) {
      var overlay = wrapper.querySelector('[data-quickview-overlay]');
      var component = wrapper.querySelector('[data-quickview-component]');
      if (overlay) overlay.classList.remove('is-open');
      if (component) component.classList.remove('is-open');
      setTimeout(function () {
        wrapper.classList.remove('is-open');
      }, CLOSE_DELAY);
      document.body.classList.remove('no-scroll');
    }

    function refreshMiniCart(html) {
      var wrapper = document.querySelector('[data-mini-cart]');
      if (!wrapper) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mini-cart]');
      if (!fresh) return;
      wrapper.innerHTML = fresh.innerHTML;
      wrapper.setAttribute('data-cart-count-value', fresh.getAttribute('data-cart-count-value') || '0');
      var badge = document.querySelector('[data-cart-count]');
      if (badge) {
        var count = wrapper.getAttribute('data-cart-count-value') || '0';
        badge.textContent = count;
        badge.classList.toggle('is-empty', count === '0');
      }
      wrapper.classList.add('is-open');
      if (window.SiteOverlay) {
        window.SiteOverlay.open('cart');
        window.SiteOverlay.lockScroll();
      }
    }

    function addToCart(buyModule) {
      var variantId = buyModule.getAttribute('data-variant-id');
      if (!variantId) return;
      var qtyEl = buyModule.querySelector('[data-quickview-qty-value]');
      var quantity = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
      var addBtn = buyModule.querySelector('[data-quickview-add-to-cart]');
      var addLabel = buyModule.querySelector('[data-quickview-add-label]');
      var originalLabel = addLabel ? addLabel.textContent : '';
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Ajout...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }], sections: 'mini_cart' })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.sections && data.sections.mini_cart) {
            refreshMiniCart(data.sections.mini_cart);
          }
          if (addLabel) addLabel.textContent = 'Ajoute !';
          setTimeout(function () {
            if (addLabel) addLabel.textContent = originalLabel;
            if (addBtn) addBtn.disabled = false;
          }, 1500);
        })
        .catch(function (err) {
          console.error('[quickview] echec ajout panier', err);
          if (addLabel) addLabel.textContent = originalLabel;
          if (addBtn) addBtn.disabled = false;
        });
    }

    document.addEventListener('click', function (e) {
      var openTrigger = e.target.closest('[data-quickview-open]');
      if (openTrigger) {
        openQuickview(openTrigger.getAttribute('data-quickview-open'));
        return;
      }

      var closeTrigger = e.target.closest('[data-quickview-close]');
      if (closeTrigger) {
        var wrapper = closeTrigger.closest('[data-quickview-wrapper]');
        if (wrapper) closeQuickview(wrapper);
        return;
      }

      var overlay = e.target.closest('[data-quickview-overlay]');
      if (overlay && e.target === overlay) {
        var overlayWrapper = overlay.closest('[data-quickview-wrapper]');
        if (overlayWrapper) closeQuickview(overlayWrapper);
        return;
      }

      var qtyMinus = e.target.closest('[data-quickview-qty-minus]');
      var qtyPlus = e.target.closest('[data-quickview-qty-plus]');
      if (qtyMinus || qtyPlus) {
        var buyModule = (qtyMinus || qtyPlus).closest('[data-quickview-buy]');
        var qtyValue = buyModule && buyModule.querySelector('[data-quickview-qty-value]');
        if (!qtyValue) return;
        var current = parseInt(qtyValue.textContent, 10) || 1;
        qtyValue.textContent = qtyMinus ? Math.max(1, current - 1) : current + 1;
        return;
      }

      var addBtn = e.target.closest('[data-quickview-add-to-cart]');
      if (addBtn && !addBtn.disabled) {
        var addBuyModule = addBtn.closest('[data-quickview-buy]');
        if (addBuyModule) addToCart(addBuyModule);
      }
    });

    var quickviewMoneyFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

    /* Le radio choisi ne met a jour que data-variant-id (utilise a l'ajout au
       panier) : sans ca le prix affiche, le prix dans le bouton, le module
       Scalapay et les Active Coins restent figes sur la variante initiale. */
    function updateQuickviewVariant(component, variantId) {
      var variantsScript = component.querySelector('[data-quickview-variants-json]');
      if (!variantsScript) return;
      var variants;
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (err) {
        return;
      }
      var variant = variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
      if (!variant) return;

      var price = variant.price / 100;
      var comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : 0;
      var onSale = comparePrice > price;

      var priceCurrent = component.querySelector('[data-quickview-price-current]');
      if (priceCurrent) {
        if (window.animateNumberUpdate) window.animateNumberUpdate(priceCurrent, price, function (v) { return quickviewMoneyFormatter.format(v); });
        else priceCurrent.textContent = quickviewMoneyFormatter.format(price);
      }
      var priceCompare = component.querySelector('[data-quickview-price-compare]');
      if (priceCompare) {
        priceCompare.hidden = !onSale;
        if (onSale) priceCompare.textContent = quickviewMoneyFormatter.format(comparePrice);
      }

      var scalapay = component.querySelector('[data-quickview-scalapay]');
      if (scalapay) {
        if (window.animateNumberUpdate) window.animateNumberUpdate(scalapay, price / 3, function (v) { return quickviewMoneyFormatter.format(v); });
        else scalapay.textContent = quickviewMoneyFormatter.format(price / 3);
      }

      var coins = component.querySelector('[data-quickview-coins]');
      if (coins) {
        if (window.animateNumberUpdate) window.animateNumberUpdate(coins, price * 2, function (v) { return Math.round(v); });
        else coins.textContent = Math.round(price * 2);
        var qvFidelity = coins.closest('.fidelity_module');
        if (qvFidelity) qvFidelity.style.display = price < 1 ? 'none' : '';
      }

      var buyModule = component.querySelector('[data-quickview-buy]');
      if (buyModule) {
        var addBtn = buyModule.querySelector('[data-quickview-add-to-cart]');
        var addLabel = buyModule.querySelector('[data-quickview-add-label]');
        if (addLabel) addLabel.textContent = variant.available ? ('AJOUTER AU PANIER - ' + quickviewMoneyFormatter.format(price)) : 'RUPTURE DE STOCK';
        if (addBtn) addBtn.disabled = !variant.available;
      }
    }

    /* Select = 1re option (ex. Gout), radio = 2e option (ex. Poids) : deux
       dimensions independantes, pas deux vues du meme choix -- il faut les
       combiner pour retrouver la variante exacte (cf. snippets/quickview.liquid).
       Si le produit n'a qu'une seule option, le radio porte directement l'id
       de la variante (pas de select dans ce cas). */
    function findQuickviewVariant(component) {
      var variantsScript = component.querySelector('[data-quickview-variants-json]');
      if (!variantsScript) return null;
      var variants;
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (err) {
        return null;
      }
      var flavorEl = component.querySelector('[data-quickview-flavor-radio]:checked');
      var radioEl = component.querySelector('[data-quickview-variant-radio]:checked');
      if (flavorEl && radioEl) {
        /* Le gout n'est pas toujours option1 (ex. Taille en 1re option) : on lit
           les cles posees par le snippet, sinon aucune variante ne correspond et
           le prix restait fige sur la variante de depart. */
        var flavorKey = variantsScript.getAttribute('data-flavor-key') || 'option1';
        var weightKey = variantsScript.getAttribute('data-weight-key') || 'option2';
        var opt1 = flavorEl.value;
        var opt2 = radioEl.value;
        return variants.filter(function (v) { return v[flavorKey] === opt1 && v[weightKey] === opt2; })[0] || null;
      }
      if (radioEl) {
        var id = radioEl.value;
        return variants.filter(function (v) { return String(v.id) === String(id); })[0] || null;
      }
      return null;
    }

    document.addEventListener('change', function (e) {
      var flavorRadio = e.target.closest('[data-quickview-flavor-radio]');
      var radio = e.target.closest('[data-quickview-variant-radio]');
      if (!flavorRadio && !radio) return;
      var component = (flavorRadio || radio).closest('.quick-view_component');
      if (!component) return;
      var variant = findQuickviewVariant(component);
      if (!variant) return;
      var buyModule = component.querySelector('[data-quickview-buy]');
      if (!buyModule) return;
      buyModule.setAttribute('data-variant-id', variant.id);
      updateQuickviewVariant(component, variant.id);

      if (variant.featured_image) {
        var qvWrapper = component.closest('[data-quickview-wrapper]');
        if (qvWrapper && qvWrapper.galleryInstance) qvWrapper.galleryInstance.scrollToImage(variant.featured_image.id);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_boutique"] && !Shopify.designMode) return;
  try {
    
  /* Bouton "Copier l'adresse" : copie la valeur dans le presse-papier et
     affiche brievement une confirmation dans le libelle. Scope a cette
     section : ce JS n'est charge que sur les pages qui ont reellement ce
     bouton. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-copy-trigger]').forEach(function (button) {
      var value = button.getAttribute('data-copy-value');
      var label = button.querySelector('[data-copy-label]');
      if (!value || !label) return;
      var originalText = label.textContent;
      var resetTimeout;
      button.addEventListener('click', function () {
        navigator.clipboard.writeText(value).then(function () {
          clearTimeout(resetTimeout);
          label.textContent = 'Adresse copiée !';
          resetTimeout = setTimeout(function () {
            label.textContent = originalText;
          }, 2000);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_categorie"] && !Shopify.designMode) return;
  try {
    
  /* Bloc "Conseils" : replie par defaut, se deplie au clic, et se rappelle
     un rejet pendant 48h via localStorage pour ne pas le remontrer a chaque
     visite. Duplique a l'identique dans header_famille.liquid (meme snippet
     snippets/conseils.liquid, 2 sections differentes) : ce JS est scope a
     la section, donc il n'est charge que sur les pages qui ont reellement
     ce bloc. */
  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.querySelector('[data-conseils-wrapper]');
    if (!wrapper) return;

    var STORAGE_KEY = 'conseils-dismissed-at';
    var DISMISS_DURATION = 48 * 60 * 60 * 1000; // 48h en millisecondes

    var dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (dismissedAt && Date.now() - Number(dismissedAt) < DISMISS_DURATION) {
      wrapper.remove();
      return; // inutile d'attacher des listeners sur un element qui n'existe deja plus
    }

    var expandBtn = wrapper.querySelector('[data-conseils-expand]');
    var collapseBtn = wrapper.querySelector('[data-conseils-collapse]');
    var target = wrapper.querySelector('[data-conseils-target]');
    var label = wrapper.querySelector('[data-conseils-label]');
    var dismissBtn = label;

    function expand() {
      if (target) target.classList.add('is-open');
      if (label) label.textContent = label.getAttribute('data-conseils-thanks-label') || 'Merci !';
      if (expandBtn) expandBtn.classList.remove('is-visible');
      if (collapseBtn) collapseBtn.classList.add('is-visible');
    }

    function collapse() {
      if (target) target.classList.remove('is-open');
      if (label) label.textContent = label.getAttribute('data-conseils-dismiss-label') || "C'est note !";
      if (collapseBtn) collapseBtn.classList.remove('is-visible');
      if (expandBtn) expandBtn.classList.add('is-visible');
    }

    function dismiss() {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
      wrapper.classList.add('is-dismissed');

      wrapper.addEventListener('transitionend', function () {
        wrapper.remove();
      }, { once: true });
    }

    if (expandBtn) expandBtn.addEventListener('click', expand);
    if (collapseBtn) collapseBtn.addEventListener('click', collapse);
    if (dismissBtn) dismissBtn.addEventListener('click', dismiss);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_famille"] && !Shopify.designMode) return;
  try {
    
  /* Bloc "Conseils" : replie par defaut, se deplie au clic, et se rappelle
     un rejet pendant 48h via localStorage pour ne pas le remontrer a chaque
     visite. Duplique a l'identique dans header_categorie.liquid (meme
     snippet snippets/conseils.liquid, 2 sections differentes) : ce JS est
     scope a la section, donc il n'est charge que sur les pages qui ont
     reellement ce bloc. */
  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.querySelector('[data-conseils-wrapper]');
    if (!wrapper) return;

    var STORAGE_KEY = 'conseils-dismissed-at';
    var DISMISS_DURATION = 48 * 60 * 60 * 1000; // 48h en millisecondes

    var dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (dismissedAt && Date.now() - Number(dismissedAt) < DISMISS_DURATION) {
      wrapper.remove();
      return; // inutile d'attacher des listeners sur un element qui n'existe deja plus
    }

    var expandBtn = wrapper.querySelector('[data-conseils-expand]');
    var collapseBtn = wrapper.querySelector('[data-conseils-collapse]');
    var target = wrapper.querySelector('[data-conseils-target]');
    var label = wrapper.querySelector('[data-conseils-label]');
    var dismissBtn = label;

    function expand() {
      if (target) target.classList.add('is-open');
      if (label) label.textContent = label.getAttribute('data-conseils-thanks-label') || 'Merci !';
      if (expandBtn) expandBtn.classList.remove('is-visible');
      if (collapseBtn) collapseBtn.classList.add('is-visible');
    }

    function collapse() {
      if (target) target.classList.remove('is-open');
      if (label) label.textContent = label.getAttribute('data-conseils-dismiss-label') || "C'est note !";
      if (collapseBtn) collapseBtn.classList.remove('is-visible');
      if (expandBtn) expandBtn.classList.add('is-visible');
    }

    function dismiss() {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
      wrapper.classList.add('is-dismissed');

      wrapper.addEventListener('transitionend', function () {
        wrapper.remove();
      }, { once: true });
    }

    if (expandBtn) expandBtn.addEventListener('click', expand);
    if (collapseBtn) collapseBtn.addEventListener('click', collapse);
    if (dismissBtn) dismissBtn.addEventListener('click', dismiss);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liste_articles"] && !Shopify.designMode) return;
  try {
    
  /* Filtrage par categorie et "Plus d'articles" en AJAX (Shopify Section
     Rendering API), meme pattern que produits_filtres.liquid : on relit le
     HTML de la section via ?section_id=, sans jamais recharger la page.
     Le clic categorie remplace #BlogListComponent-* (categories + liste,
     pour mettre a jour l'etat actif) ; le clic "Plus d'articles" ajoute
     uniquement les nouveaux articles a la liste existante (comportement
     "load more", pas une pagination classique). */
  (function () {
    var root = document.querySelector('[data-blog-root]');
    if (!root) return;
    var SECTION_ID = root.getAttribute('data-section-id');
    var contentId = 'BlogListComponent-' + SECTION_ID;
    var isFetching = false;

    function fetchAndReplace(fetchUrl, pushUrl) {
      if (isFetching) return;
      isFetching = true;
      var content = document.getElementById(contentId);
      if (content) content.classList.add('is-loading');
      fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(contentId);
          var current = document.getElementById(contentId);
          if (!fresh || !current) return;
          current.innerHTML = fresh.innerHTML;
          if (typeof window.initScrollReveal === 'function') window.initScrollReveal(current);
          if (pushUrl !== null) history.pushState({}, '', pushUrl);
          window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 32, behavior: 'smooth' });
        })
        .catch(function (err) {
          console.error('[blog] echec du chargement', err);
        })
        .finally(function () {
          isFetching = false;
          var contentAfter = document.getElementById(contentId);
          if (contentAfter) contentAfter.classList.remove('is-loading');
        });
    }

    function fetchAndAppend(fetchUrl, loadMoreLink) {
      if (isFetching) return;
      isFetching = true;
      loadMoreLink.classList.add('is-loading');
      fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshList = doc.querySelector('#' + contentId + ' .blog_list');
          var currentList = document.querySelector('#' + contentId + ' .blog_list');
          if (freshList && currentList) {
            var newItems = Array.from(freshList.children);
            newItems.forEach(function (item) {
              item.classList.add('is-appearing');
              currentList.appendChild(item);
            });
            requestAnimationFrame(function () {
              newItems.forEach(function (item) {
                item.classList.remove('is-appearing');
              });
            });
            /* Sans ca, les elements ajoutes apres coup restent inobserves par
               l'IntersectionObserver global (voir layout/theme.liquid) et
               donc figes a opacity:0 pour toujours -- c'est le bug precis que
               le commentaire de initScrollReveal met en garde. On passe
               document (comme l'appel initial) et non currentList : la
               fonction cherche [data-animate-stagger] par querySelectorAll,
               qui ne matche jamais l'element racine passe en scope lui-meme
               -- passer currentList (qui PORTE l'attribut) ne trouvait donc
               rien et ne faisait rien. Reobserver tout le document est sans
               effet indesirable : les elements deja reveles sont juste
               re-observes puis immediatement desobserves par le callback. */
            if (typeof window.initScrollReveal === 'function') window.initScrollReveal(document);
          }
          var freshPagination = doc.querySelector('#' + contentId + ' [data-pagination-wrapper]');
          var currentPagination = document.querySelector('#' + contentId + ' [data-pagination-wrapper]');
          if (currentPagination) {
            if (freshPagination) {
              currentPagination.replaceWith(freshPagination);
            } else {
              currentPagination.remove();
            }
          }
        })
        .catch(function (err) {
          console.error('[blog] echec du chargement', err);
        })
        .finally(function () {
          isFetching = false;
        });
    }

    root.addEventListener('click', function (e) {
      var loadMoreLink = e.target.closest('[data-load-more]');
      if (loadMoreLink) {
        e.preventDefault();
        var nextUrl = new URL(loadMoreLink.href, window.location.origin);
        nextUrl.searchParams.set('section_id', SECTION_ID);
        fetchAndAppend(nextUrl.toString(), loadMoreLink);
        return;
      }

      var categoryLink = e.target.closest('.blog_category-link');
      if (categoryLink) {
        e.preventDefault();
        var url = new URL(categoryLink.href, window.location.origin);
        var fetchUrl = new URL(url.toString());
        fetchUrl.searchParams.set('section_id', SECTION_ID);
        fetchAndReplace(fetchUrl.toString(), url.toString());
      }
    });

    window.addEventListener('popstate', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('section_id', SECTION_ID);
      fetchAndReplace(url.toString(), null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini_cart"]) return;
  try {
    
  /* Mini-panier — couche AJAX.
     Attention : Liquid n'est pas interprete dans ce bloc. Toute la
     configuration transite par des attributs data-* poses sur le wrapper. */
  (function () {
    var SECTION_ID = 'mini_cart';
    var UPSELL_SECTION_ID = 'mini_cart_upsell';
    var UPSELL_FALLBACK = 'meilleures-ventes';

    /* Numero croissant attribue a chaque requete qui va re-rendre la section.
       Si des reponses reviennent dans le desordre (rafale de clics sur +/-,
       requetes concurrentes), on n'applique que la reponse de la requete la
       plus recemment envoyee -- les autres sont perimees et ignorees. */
    var requestSeq = 0;
    /* Un code peut s'appliquer au panier entier (cart_level_discount_applications)
       OU seulement a certaines lignes (ex. NEWLIFE15, limite a une collection) :
       dans ce cas Shopify ne le met que dans discount_applications / dans les
       remises de chaque ligne. On regarde les trois, sinon un code valide etait
       annonce comme « invalide ou expire ». */
    function discountCodeApplied(data, code) {
      if (!data || !code) return false;
      var wanted = code.trim().toLowerCase();
      function match(d) {
        var title = (d && (d.title || d.code || '')).toString().trim().toLowerCase();
        return title === wanted;
      }
      var lists = [data.cart_level_discount_applications, data.discount_applications];
      for (var i = 0; i < lists.length; i++) {
        if (lists[i] && lists[i].some(match)) return true;
      }
      var items = data.items || [];
      for (var j = 0; j < items.length; j++) {
        var it = items[j];
        if (it.discounts && it.discounts.some(match)) return true;
        if (it.line_level_discount_allocations && it.line_level_discount_allocations.some(function (a) {
          return match(a && a.discount_application);
        })) return true;
      }
      return false;
    }

    /* Essai d'un code promo sans perdre ceux deja appliques (dont le code
       Joy des Active Coins). Shopify dit seulement « applicable » ou non :
       pour distinguer un code faux d'un code non cumulable, on le reessaie
       seul, puis on remet toujours les codes d'avant. Resultat : statut
       'ok' | 'cumul' | 'invalide', data = dernier cart.json (avec sections). */
    function essaiCodePromo(code, sections) {
      var bas = code.toLowerCase();
      function maj(discount) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: discount, sections: sections })
        }).then(function (r) { return r.json(); });
      }
      function codes(data) { return (data && data.discount_codes) || []; }
      function trouve(data) {
        return codes(data).filter(function (c) { return String(c.code).toLowerCase() === bas; })[0];
      }
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (panier) {
          var avant = codes(panier)
            .filter(function (c) { return c.applicable && String(c.code).toLowerCase() !== bas; })
            .map(function (c) { return c.code; });
          return maj(avant.concat(code).join(',')).then(function (data) {
            if (!Array.isArray(data.discount_codes)) {
              return { statut: discountCodeApplied(data, code) ? 'ok' : 'invalide', data: data, avant: avant };
            }
            var nouveau = trouve(data);
            var perdus = codes(data).filter(function (c) { return !c.applicable && String(c.code).toLowerCase() !== bas; });
            if (nouveau && nouveau.applicable && !perdus.length) return { statut: 'ok', data: data, avant: avant };
            var seul = avant.length
              ? maj(code).then(function (d) { var n = trouve(d); return !!(n && n.applicable); })
              : Promise.resolve(false);
            return seul.then(function (marcheSeul) {
              /* Non cumulable avec un code Joy (Active Coins) : le nouveau code
                 le remplace, et on REVOQUE le code Joy pour que les points
                 reviennent au client (snippets/joy_redeem.liquid). Si la
                 revocation echoue, on remet le code Joy et on previent. */
              var joyCodes = avant.filter(function (c) { return /^(joy|active)-/i.test(c); });
              if (marcheSeul && joyCodes.length && typeof window.ALJoyRevoke === 'function') {
                return window.ALJoyRevoke(joyCodes[0])
                  .then(function () { return maj(code); })
                  .then(function (d3) { return { statut: 'remplace', data: d3, avant: avant }; })
                  .catch(function () {
                    return maj(avant.join(',')).then(function (d4) { return { statut: 'cumul', data: d4, avant: avant }; });
                  });
              }
              return maj(avant.join(',')).then(function (d2) {
                return { statut: marcheSeul ? 'cumul' : 'invalide', data: d2, avant: avant };
              });
            });
          });
        });
    }

    function messageCodePromo(res) {
      if (res.statut === 'remplace') return 'Code appliqué à la place de tes Active Coins : tes points t’ont été rendus.';
      /* 'invalide' couvre aussi un code valable mais pas sur ces articles
         (ex. la whey, exclue des codes promo) : Shopify ne fait pas la difference. */
      if (res.statut !== 'cumul') return 'Code invalide, expiré ou non valable sur les articles de ton panier.';
      var joy = res.avant.some(function (c) { return /^(joy|active)-/i.test(c); /* codes Joy (prefixe « Active- » depuis septembre) */ });
      return joy
        ? 'Ce code ne se cumule pas avec tes Active Coins déjà utilisés : retire-les pour l’utiliser.'
        : 'Ce code ne se cumule pas avec le code « ' + res.avant[0] + ' » déjà appliqué : retire-le pour l’utiliser.';
    }

    /* Croix -> petite roue pendant le retrait du code (le panier se
       re-rend ensuite, donc pas besoin de remettre la croix). */
    function setRemoveLoading(btn, loading) {
      if (!btn) return;
      var icon = btn.querySelector('[data-cart-discount-remove-icon]');
      var loader = btn.querySelector('[data-cart-discount-remove-loader]');
      if (icon) icon.style.display = loading ? 'none' : '';
      if (loader) loader.hidden = !loading;
    }

    function nextRequestSeq() {
      requestSeq += 1;
      return requestSeq;
    }

    function wrapper() {
      return document.querySelector('[data-mini-cart]');
    }

    var cartMoneyFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
    function formatMoney(amount) {
      return cartMoneyFormatter.format(amount);
    }

    /* Retrouve la valeur numerique a partir du texte deja affiche (ex.
       "24,90 €" -> 24.9) : le HTML frais renvoye par Shopify ne porte que du
       texte formate, jamais le nombre brut, et c'est de toute facon la seule
       valeur "avant" disponible juste avant que innerHTML ne soit remplace. */
    function parseMoneyText(text) {
      if (!text) return NaN;
      var cleaned = text.replace(/[^\d,]/g, '').replace(',', '.');
      var value = parseFloat(cleaned);
      return isNaN(value) ? NaN : value;
    }

    function openDrawer() {
      var w = wrapper();
      if (!w) return;
      w.classList.add('is-open');
      if (window.SiteOverlay) {
        window.SiteOverlay.open('cart');
        window.SiteOverlay.lockScroll();
      }
    }

    function closeDrawer() {
      var w = wrapper();
      if (!w) return;
      w.classList.remove('is-open');
      if (window.SiteOverlay) {
        window.SiteOverlay.close();
        window.SiteOverlay.unlockScroll();
      }
    }

    /* Le bouton de fermeture fait partie du contenu remplace : son ecouteur
       meurt a chaque rendu. utility_scripts le relie au chargement initial,
       on prend le relais ensuite. */
    function bindClose() {
      var btn = document.querySelector('[data-mini-cart] [data-cart-close]');
      if (btn) btn.addEventListener('click', closeDrawer);
    }

    /* La pastille vit dans la navbar, une autre section : plutot que de la
       rerendre, on lit le compteur transmis par le mini-panier. */
    function updateCount() {
      var w = wrapper();
      var badge = document.querySelector('[data-cart-count]');
      if (!w || !badge) return;
      var count = w.getAttribute('data-cart-count-value') || '0';
      badge.textContent = count;
      badge.classList.toggle('is-empty', count === '0');
    }

    function render(html) {
      var w = wrapper();
      if (!w) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mini-cart]');
      if (!fresh) return;

      /* Valeurs affichees AVANT remplacement (texte deja rendu) : seule
         source "avant" disponible ici, capturee juste avant l'ecrasement du
         contenu, pour pouvoir animer le passage vers les nouvelles valeurs
         plutot qu'un saut sec. */
      var oldTotalEl = w.querySelector('[data-cart-total-price]');
      var oldTotalValue = oldTotalEl ? parseMoneyText(oldTotalEl.textContent) : NaN;
      var oldLinePrices = {};
      w.querySelectorAll('[data-cart-item-price]').forEach(function (el) {
        var line = el.getAttribute('data-cart-line');
        var value = parseMoneyText(el.textContent);
        if (line && !isNaN(value)) oldLinePrices[line] = value;
      });

      /* On remplace le contenu et non le wrapper : le noeud reste vivant,
         donc l'etat d'ouverture et la reference tenue par utility_scripts
         survivent au rafraichissement. */
      w.innerHTML = fresh.innerHTML;
      w.setAttribute('data-cart-count-value', fresh.getAttribute('data-cart-count-value') || '0');

      if (window.animateNumberUpdate) {
        var totalEl = w.querySelector('[data-cart-total-price]');
        if (totalEl) {
          var newTotalValue = parseMoneyText(totalEl.textContent);
          if (!isNaN(newTotalValue)) {
            if (!isNaN(oldTotalValue)) totalEl.setAttribute('data-animate-value', oldTotalValue);
            window.animateNumberUpdate(totalEl, newTotalValue, formatMoney);
          }
        }
        w.querySelectorAll('[data-cart-item-price]').forEach(function (el) {
          var line = el.getAttribute('data-cart-line');
          var newValue = parseMoneyText(el.textContent);
          if (isNaN(newValue)) return;
          var oldValue = oldLinePrices[line];
          if (typeof oldValue === 'number') el.setAttribute('data-animate-value', oldValue);
          window.animateNumberUpdate(el, newValue, formatMoney);
        });
      }

      bindClose();
      updateCount();
      loadUpsell();
      /* Deux rendus rapproches (ex. ajout via l'achat rapide, puis mise a jour
         du panier) peuvent perdre la reponse des recommandations : elle arrive
         dans un contenu deja remplace. On relance si le slider reste vide. */
      setTimeout(function () {
        var upsellHost = document.querySelector('[data-cart-upsell]');
        if (upsellHost && !upsellHost.children.length) loadUpsell();
      }, 900);
    }

    /* Exposes pour les scripts du theme qui rafraichissent le tiroir sans
       passer par ici (ex. snippets/joy_redeem.liquid) : render() re-rend le
       contenu ET relance le chargement des recommandations. */
    window.ALCartRender = function (html) { render(html); };
    window.ALCartLoadUpsell = function () { loadUpsell(); };
    window.ALCartRefresh = function () { refresh(); };

    /* Les fiches produit et les articles reconstruisent le tiroir eux-memes
       apres un ajout (innerHTML de [data-mini-cart]) sans passer par render() :
       on surveille ce remplacement pour recharger le slider d'upsell, sinon il
       restait vide. Seuls les enfants directs sont observes : peindre le slider
       ne redeclenche donc rien. */
    (function () {
      var w = wrapper();
      if (!w || !window.MutationObserver) return;
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var h = document.querySelector('[data-cart-upsell]');
          if (h && !h.children.length) loadUpsell();
        }, 150);
      }).observe(w, { childList: true });
    })();

    function refresh() {
      fetch(window.location.pathname + '?section_id=' + SECTION_ID)
        .then(function (r) { return r.text(); })
        .then(render)
        .catch(function () {});
    }

    function post(route, body) {
      body.sections = SECTION_ID;
      return fetch(route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    /* La page panier (sections/cart.liquid) est presente sur le DOM meme
       quand on est sur /cart (le tiroir est global, rendu par theme.liquid) :
       si son wrapper existe, on le rafraichit aussi apres une application de
       code promo pour eviter un total desynchronise entre les deux. */
    function renderCartPage(html) {
      var root = document.querySelector('[data-cart-section]');
      if (!root) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
      if (!fresh) return;
      root.innerHTML = fresh.innerHTML;
    }

    function applyResponse(data, seq) {
      if (typeof seq === 'number' && seq < requestSeq) return;
      if (data && data.sections && data.sections[SECTION_ID]) {
        render(data.sections[SECTION_ID]);
      } else {
        /* Erreur panier (stock insuffisant, ligne disparue...) : on resynchronise
           sur l'etat reel plutot que de laisser un affichage faux. */
        refresh();
      }
    }

    /* anime = true quand le slider arrive apres un appel reseau (il
       apparaitrait d'un coup) ; depuis le cache, il est peint pendant le
       rendu du tiroir, sans a-coup visible, donc sans animation. */
    function paintUpsell(host, html, anime) {
      /* Le tiroir a pu etre re-rendu pendant l'appel (ajout au panier, module
         Joy...) : l'ancien conteneur n'est plus dans la page, on peint dans
         le conteneur actuel, sinon le slider restait vide. */
      if (!host.isConnected) {
        var actuel = document.querySelector('[data-cart-upsell]');
        if (!actuel) return;
        host = actuel;
      }
      var etaitVide = !host.children.length;
      host.innerHTML = html;
      if (anime && etaitVide && html) {
        var bloc = host.querySelector('.nav_cart-upsell');
        if (bloc) bloc.classList.add('is-appearing');
      }
      var slider = host.querySelector('.embla');
      if (slider && typeof window.initEmbla === 'function') window.initEmbla(slider);
    }

    function loadUpsell() {
      var host = document.querySelector('[data-cart-upsell]');
      if (!host) return;
      var pid = host.getAttribute('data-cart-upsell-product');
      if (!pid) { host.innerHTML = ''; return; }
      var limit = host.getAttribute('data-cart-upsell-limit') || '6';
      var intent = host.getAttribute('data-cart-upsell-intent') || 'related';
      var fallbacks = (host.getAttribute('data-cart-upsell-fallbacks') || '')
        .split(',')
        .filter(function (id) { return id && id !== pid; });
      if (Object.prototype.hasOwnProperty.call(upsellCache, pid) && upsellCache[pid]) {
        paintUpsell(host, upsellCache[pid]);
        return;
      }
      fetchRecommendations(host, pid, limit, intent, fallbacks);
    }

    /* Les recommandations ne dependent que du dernier produit ajoute : inutile
       de rappeler la route a chaque changement de quantite. */
    var upsellCache = {};

    /* 'complementary' ne renvoie des produits que si l'app Search & Discovery
       est configuree. Sans elle la reponse est vide : on retombe sur 'related'
       plutot que d'afficher un slider absent. */
    function fetchRecommendations(host, pid, limit, intent, restants) {
      fetch('/recommendations/products?section_id=' + UPSELL_SECTION_ID +
            '&product_id=' + pid + '&limit=' + limit + '&intent=' + intent)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var content = new DOMParser().parseFromString(html, 'text/html').querySelector('.nav_cart-upsell');
          if (!content && intent === 'complementary') {
            fetchRecommendations(host, pid, limit, 'related', restants);
            return;
          }
          /* Shopify ne renvoie parfois aucune recommandation pour le dernier
             produit ajoute : on essaie alors les autres produits du panier
             plutot que de laisser le slider vide. */
          if (!content && restants && restants.length) {
            fetchRecommendations(host, restants[0], limit, intent, restants.slice(1));
            return;
          }
          /* Aucune recommandation pour aucun produit du panier : dernier repli
             sur les meilleures ventes (hors produits deja au panier). */
          if (!content) {
            fetch('/collections/' + UPSELL_FALLBACK + '?section_id=' + UPSELL_SECTION_ID)
              .then(function (r) { return r.text(); })
              .then(function (html2) {
                var repli = new DOMParser().parseFromString(html2, 'text/html').querySelector('.nav_cart-upsell');
                upsellCache[pid] = repli ? repli.outerHTML : '';
                if (repli || !host.children.length) paintUpsell(host, upsellCache[pid], true);
              })
              .catch(function () {});
            return;
          }
          upsellCache[pid] = content ? content.outerHTML : '';
          if (content || !host.children.length) paintUpsell(host, upsellCache[pid], true);
        })
        .catch(function () {});
    }

    /* Bascule visuelle le temps de l'appel API : le lien Supprimer cede sa
       place au loader le temps de la reponse, puis le re-rendu de la section
       remet tout a plat (le loader repart 'hidden' dans le HTML frais). */
    function showLineLoader(line) {
      var item = document.querySelector('[data-mini-cart] [data-cart-line="' + line + '"]');
      if (!item) return;
      var deleteLink = item.querySelector('[data-cart-remove]');
      var loader = item.querySelector('[data-cart-line-loader]');
      if (deleteLink) deleteLink.hidden = true;
      if (loader) loader.hidden = false;
    }

    /* max-height mesure au moment de l'ouverture (pas de valeur fixe en dur) :
       le contenu varie selon qu'un code est deja applique ou non. */
    function setDiscountAccordionOpen(accordion, open) {
      var body = accordion && accordion.querySelector('[data-cart-discount-body]');
      var trigger = accordion && accordion.querySelector('[data-cart-discount-trigger]');
      if (!accordion || !body) return;
      accordion.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open);
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
    }

    /* /cart/change.js ne renvoie pas le panier mais {status, description} si
       Shopify a du limiter la quantite (stock insuffisant) : le nombre
       demande n'est alors pas celui reellement applique. On construit un
       message francais a partir du nombre trouve dans la reponse plutot que
       d'afficher le texte anglais brut de Shopify. */
    function buildStockMessage(data) {
      var raw = (data && (data.description || data.message)) || '';
      var match = /(\d+)/.exec(raw);
      if (match) return 'Quantité limitée à ' + match[1] + ' (stock disponible).';
      return raw || 'Quantité limitée par le stock disponible.';
    }

    var stockMessageTimers = {};
    function showStockMessage(line, message) {
      var item = document.querySelector('[data-mini-cart] [data-cart-line="' + line + '"]');
      var el = item && item.querySelector('[data-cart-stock-message]');
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
      if (stockMessageTimers[line]) clearTimeout(stockMessageTimers[line]);
      stockMessageTimers[line] = setTimeout(function () { el.hidden = true; }, 6000);
    }

    /* Pousse add_to_cart (quantite augmentee) ou remove_from_cart (quantite
       diminuee/supprimee) a partir des data-item-* portes par la ligne --
       voir assets/li_datalayer.js. Ne fait rien si la quantite n'a pas
       change (ex. clic sur "-" deja a 1). */
    function trackQuantityDelta(line, oldQuantity, newQuantity) {
      if (!window.ALDataLayer || oldQuantity === newQuantity) return;
      var item = document.querySelector('[data-mini-cart] [data-cart-line="' + line + '"]');
      if (!item) return;
      var price = parseFloat(item.getAttribute('data-item-price'));
      var base = {
        item_id: item.getAttribute('data-item-id') || undefined,
        item_name: item.getAttribute('data-item-name') || undefined,
        item_brand: item.getAttribute('data-item-brand') || undefined,
        item_category: item.getAttribute('data-item-category') || undefined,
        price: isNaN(price) ? undefined : price
      };
      var variant = item.getAttribute('data-item-variant');
      if (variant) base.item_variant = variant;
      var delta = newQuantity - oldQuantity;
      if (delta > 0) {
        window.ALDataLayer.addToCart([Object.assign({}, base, { quantity: delta })]);
      } else {
        window.ALDataLayer.removeFromCart([Object.assign({}, base, { quantity: -delta })]);
      }
    }

    /* Partagee entre la saisie directe dans l'input et les boutons -/+. */
    function updateQuantity(line, quantity) {
      showLineLoader(line);
      var seq = nextRequestSeq();
      post('/cart/change.js', {
        line: line,
        quantity: quantity
      }).then(function (data) {
        if (data && data.status) {
          var message = buildStockMessage(data);
          /* /cart/update.js sans rien a modifier : sert juste a relire des
             sections a jour, deja la meme astuce que pour le code promo. */
          post('/cart/update.js', {}).then(function (fresh) {
            applyResponse(fresh, seq);
            showStockMessage(line, message);
          }).catch(refresh);
          return;
        }
        applyResponse(data, seq);
      }).catch(refresh);
    }

    /* Un clic sur +/- met a jour l'affichage tout de suite, mais n'envoie la
       requete qu'apres une courte pause : sans ca, "bombarder" les boutons
       envoie une requete par clic, et une reponse en retard peut ecraser un
       etat plus recent. Une rafale de clics ne produit donc plus qu'un seul
       appel /cart/change.js, avec la quantite finale. */
    var quantityTimers = {};
    function scheduleQuantityUpdate(line, quantity) {
      showLineLoader(line);
      if (quantityTimers[line]) clearTimeout(quantityTimers[line]);
      quantityTimers[line] = setTimeout(function () {
        delete quantityTimers[line];
        updateQuantity(line, quantity);
      }, 400);
    }

    document.addEventListener('change', function (e) {
      if (!(e.target instanceof Element)) return;
      var input = e.target.closest('[data-mini-cart] [data-cart-quantity]');
      if (!input) return;
      var line = Number(input.getAttribute('data-cart-line'));
      var oldQuantity = Math.max(1, Math.floor(Number(input.defaultValue)) || 1);
      var quantity = Math.max(1, Math.floor(Number(input.value)) || 1);
      trackQuantityDelta(line, oldQuantity, quantity);
      updateQuantity(line, quantity);
    });

    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;

      var quantityBtn = e.target.closest('[data-cart-quantity-minus], [data-cart-quantity-plus]');
      if (quantityBtn) {
        var wrapper = quantityBtn.closest('[data-mini-cart] .nav_cart-item-quantity-wrapper');
        var input = wrapper && wrapper.querySelector('[data-cart-quantity]');
        if (!input) return;
        var line = Number(quantityBtn.getAttribute('data-cart-line'));
        var delta = quantityBtn.hasAttribute('data-cart-quantity-minus') ? -1 : 1;
        var oldQuantity = parseInt(input.value, 10) || 1;
        var quantity = Math.max(1, oldQuantity + delta);
        if (quantity === oldQuantity) return;
        input.value = quantity;
        trackQuantityDelta(line, oldQuantity, quantity);
        scheduleQuantityUpdate(line, quantity);
        return;
      }

      var remove = e.target.closest('[data-mini-cart] [data-cart-remove]');
      if (remove) {
        e.preventDefault();
        var removeLine = Number(remove.getAttribute('data-cart-line'));
        var removeItem = document.querySelector('[data-mini-cart] [data-cart-line="' + removeLine + '"]');
        var removeInput = removeItem && removeItem.querySelector('[data-cart-quantity]');
        var removeOldQuantity = removeInput ? (parseInt(removeInput.value, 10) || 1) : 1;
        trackQuantityDelta(removeLine, removeOldQuantity, 0);
        showLineLoader(removeLine);
        var removeSeq = nextRequestSeq();
        post('/cart/change.js', {
          line: removeLine,
          quantity: 0
        }).then(function (data) { applyResponse(data, removeSeq); }).catch(refresh);
        return;
      }

      var checkoutLink = e.target.closest('[data-cart-checkout]');
      if (checkoutLink) {
        if (window.ALDataLayer) {
          var checkoutItems = Array.from(document.querySelectorAll('[data-mini-cart] [data-item-id]')).map(function (item) {
            var price = parseFloat(item.getAttribute('data-item-price'));
            var qtyInput = item.querySelector('[data-cart-quantity]');
            var out = {
              item_id: item.getAttribute('data-item-id') || undefined,
              item_name: item.getAttribute('data-item-name') || undefined,
              item_brand: item.getAttribute('data-item-brand') || undefined,
              item_category: item.getAttribute('data-item-category') || undefined,
              price: isNaN(price) ? undefined : price,
              quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
            };
            var variant = item.getAttribute('data-item-variant');
            if (variant) out.item_variant = variant;
            return out;
          });
          window.ALDataLayer.beginCheckout(checkoutItems);
        }
        return;
      }

      var add = e.target.closest('[data-cart-upsell-add]');
      if (add) {
        e.preventDefault();
        var w = wrapper();
        var openOnAdd = !w || w.getAttribute('data-cart-open-on-add') !== 'false';
        var addSeq = nextRequestSeq();
        post('/cart/add.js', {
          items: [{ id: Number(add.getAttribute('data-variant-id')), quantity: 1 }]
        }).then(function (data) {
          applyResponse(data, addSeq);
          if (openOnAdd) openDrawer();
        }).catch(refresh);
        return;
      }

      var discountTrigger = e.target.closest('[data-cart-discount-trigger]');
      if (discountTrigger) {
        var accordion = discountTrigger.closest('[data-cart-discount-accordion]');
        if (accordion) {
          setDiscountAccordionOpen(accordion, !accordion.classList.contains('is-open'));
        }
        return;
      }

      var discountRemove = e.target.closest('[data-cart-discount-remove]');
      if (discountRemove) {
        e.preventDefault();
        discountRemove.disabled = true;
        setRemoveLoading(discountRemove, true);
        /* Shopify n'a pas de route « retirer le code » : on renvoie un code
           vide a /cart/update.js, ce qui detache la remise de la session. */
        var removeSeq = nextRequestSeq();
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: '', sections: SECTION_ID + ',cart' })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (removeSeq < requestSeq) return;
            if (data && data.sections && data.sections[SECTION_ID]) render(data.sections[SECTION_ID]);
            if (data && data.sections && data.sections.cart) renderCartPage(data.sections.cart);
          })
          .catch(refresh);
        return;
      }

      var discountApply = e.target.closest('[data-cart-discount-apply]');
      if (discountApply) {
        e.preventDefault();
        var discountInput = document.querySelector('[data-mini-cart] [data-cart-discount-input]');
        var code = discountInput ? discountInput.value.trim() : '';
        if (!code) return;
        var discountLabel = discountApply.querySelector('[data-cart-discount-label]');
        var discountLoader = discountApply.querySelector('[data-cart-discount-loader]');
        if (discountLabel) discountLabel.hidden = true;
        if (discountLoader) discountLoader.hidden = false;
        discountApply.disabled = true;

        /* Meme mecanisme que sections/cart.liquid : fetch (pas de navigation)
           vers la route native /discount/[code], puis un /cart/update.js a
           vide pour relire un cart.json a jour et savoir si le code a ete
           accepte (Shopify ne renvoie aucune erreur exploitable sur la
           premiere requete). */
        var discountSeq = nextRequestSeq();
        essaiCodePromo(code, SECTION_ID + ',cart')
          .then(function (res) {
            var data = res.data;
            if (discountSeq < requestSeq) return;
            if (data && data.sections && data.sections[SECTION_ID]) render(data.sections[SECTION_ID]);
            if (data && data.sections && data.sections.cart) renderCartPage(data.sections.cart);

            var appliedNow = res.statut === 'ok' || res.statut === 'remplace';
            if (appliedNow && window.ALDataLayer) {
              window.ALDataLayer.event('coupon_applied', { coupon: code, value: data.total_price ? data.total_price / 100 : undefined });
            }
            if (res.statut !== 'ok') {
              var freshError = document.querySelector('[data-mini-cart] [data-cart-discount-error]');
              if (freshError) {
                freshError.textContent = messageCodePromo(res);
                freshError.hidden = false;
              }
            }
            /* Le re-rendu repart toujours ferme (etat par defaut du Liquid) :
               on rouvre pour que le resultat (succes ou erreur) reste visible.
               L'erreur doit deja etre demasquee avant de mesurer la hauteur
               (setDiscountAccordionOpen lit le scrollHeight courant). */
            var freshAccordion = document.querySelector('[data-mini-cart] [data-cart-discount-accordion]');
            if (freshAccordion) setDiscountAccordionOpen(freshAccordion, true);
          })
          .catch(refresh);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadUpsell);
    } else {
      loadUpsell();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navbar"] && !Shopify.designMode) return;
  try {
    
  /* Recherche predictive.
     Liquid n'est pas interprete dans ce bloc : rien de configurable ici.

     L'ouverture du panneau et la bascule entre l'etat "avant recherche" et les
     resultats restent geres par snippets/utility_scripts.liquid. On ne
     s'occupe que d'aller chercher les donnees. */
  (function () {
    var SECTION_ID = 'predictive_search';
    var DEBOUNCE_MS = 250;
    var LIMIT = 6;

    var input = document.querySelector('[data-search-input]');
    var host = document.querySelector('[data-search-results]');
    if (!input || !host) return;

    var timer = null;
    var controller = null;
    var lastTrackedTerm = null;

    function run(term) {
      /* Une frappe rapide enchaine les requetes : on annule la precedente pour
         qu'une reponse lente n'ecrase pas un resultat plus recent. */
      if (controller) controller.abort();
      controller = new AbortController();

      var url = '/search/suggest'
        + '?q=' + encodeURIComponent(term)
        + '&section_id=' + SECTION_ID
        + '&resources%5Btype%5D=product,query'
        + '&resources%5Blimit%5D=' + LIMIT;

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var section = new DOMParser().parseFromString(html, 'text/html')
            .querySelector('#shopify-section-' + SECTION_ID);
          host.innerHTML = section ? section.innerHTML : '';
          if (typeof window.initScrollReveal === 'function') window.initScrollReveal(host);
          if (window.ALDataLayer) {
            window.ALDataLayer.scanItems(host);
            /* Deduplique sur le terme (pas sur chaque frappe/debounce) :
               retaper le meme mot apres un backspace ne doit pas repousser
               un evenement identique. */
            if (term !== lastTrackedTerm) {
              lastTrackedTerm = term;
              var resultsCount = host.querySelectorAll('[data-item-id]').length;
              window.ALDataLayer.event('search', { search_term: term, results_count: resultsCount });
            }
          }
        })
        .catch(function (e) {
          if (e.name !== 'AbortError') host.innerHTML = '';
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (controller) { controller.abort(); controller = null; }
      if (!term) { host.innerHTML = ''; return; }
      timer = setTimeout(function () { run(term); }, DEBOUNCE_MS);
    });

    /* Clic sur une suggestion : on remplace le terme et on relance. On passe
       par un evenement input pour reutiliser le meme chemin que la frappe —
       utility_scripts y reagit aussi pour maintenir l’etat du panneau. */
    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;
      var suggestion = e.target.closest('[data-search-suggestion]');
      if (!suggestion) return;
      e.preventDefault();
      input.value = suggestion.getAttribute('data-search-suggestion') || '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    });

    /* Entree mene a la page de resultats complete.
       Avant le 30/09 la validation etait neutralisee : le theme n'avait pas
       de gabarit /search, sortir de la modale menait au rendu par defaut de
       Shopify (liste numerotee, sans cartes produit). Le gabarit existe
       desormais.

       Les parametres sont poses ici parce qu'ils conditionnent la pertinence :
       produits seuls, ruptures renvoyees en fin de liste, correspondance
       partielle sur le dernier mot tape. L'adresse est ecrite en dur : le
       contenu d'un bloc {% javascript %} est servi comme un asset statique,
       Liquid n'y est pas interprete (d'ou le '/search/suggest' en dur plus
       haut). */
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      var terme = input.value.trim();
      if (!terme) return;
      window.location.href = '/search'
        + '?q=' + encodeURIComponent(terme)
        + '&type=product'
        + '&options%5Bunavailable_products%5D=last'
        + '&options%5Bprefix%5D=last';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produits_filtres"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-filters-root]');
    if (!root) return;
    /* section.id n'est pas forcement le nom du fichier de section : sur une
       page personnalisee depuis l'editeur de theme, Shopify lui attribue un
       identifiant genere (ex. "template--123__produits_filtres"). L'API de
       rendu de sections exige cet identifiant exact pour section_id — un
       nom fixe ne correspond au bon rendu que par coincidence, d'ou le
       freshFound: false constate en test (id different sur ce store). */
    var SECTION_ID = root.getAttribute('data-section-id');
    var contentId = 'ProductsListComponent-' + SECTION_ID;
    var isLoadingMore = false;
    var collectionUrl = root.getAttribute('data-collection-url');
    var collectionId = root.getAttribute('data-collection-id');
    var collectionTitle = root.getAttribute('data-collection-title');
    var applyFiltersDebounced; // assignee plus bas, utilisee par initPriceSliders

    function debounce(fn, ms) {
      var timer;
      return function () {
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () { fn.apply(null, args); }, ms);
      };
    }

    /* Slider de prix a 2 poignees. Repris du script Webflow d'origine
       (meme logique valueToPercent/percentToValue/updateUI) mais attache
       via des fonctions rappelees a chaque fetch AJAX plutot qu'une fois au
       DOMContentLoaded — le contenu de #ProductsListComponent-* (donc les
       poignees elles-memes) est entierement remplace par le HTML renvoye
       par le serveur a chaque changement de filtre, des ecouteurs poses
       une seule fois au chargement ne survivraient pas au premier fetch. */
    function initPriceSliders(scope) {
      scope.querySelectorAll('[data-range-wrapper]').forEach(function (wrapper) {
        var track = wrapper.querySelector('.product_filter-range-slider');
        var fill = wrapper.querySelector('[data-range-fill]');
        var minHandle = wrapper.querySelector('[data-range-handle="min"]');
        var maxHandle = wrapper.querySelector('[data-range-handle="max"]');
        var minInput = wrapper.querySelector('[data-range-input="min"]');
        var maxInput = wrapper.querySelector('[data-range-input="max"]');
        if (!track || !minHandle || !maxHandle) return;

        var min = parseFloat(wrapper.getAttribute('data-range-min')) || 0;
        var max = parseFloat(wrapper.getAttribute('data-range-max')) || 100;
        var step = parseFloat(wrapper.getAttribute('data-range-step')) || 1;

        var minValue = minInput && minInput.value !== '' ? parseFloat(minInput.value) : min;
        var maxValue = maxInput && maxInput.value !== '' ? parseFloat(maxInput.value) : max;

        function valueToPercent(value) {
          if (max === min) return 0;
          return ((value - min) / (max - min)) * 100;
        }

        function percentToValue(percent) {
          var raw = min + (percent / 100) * (max - min);
          var stepped = Math.round(raw / step) * step;
          return Math.min(max, Math.max(min, stepped));
        }

        /* syncInputs=false pour le peint initial : les champs de prix ne
           doivent rester REELLEMENT vides que si aucun filtre n'est actif —
           sinon on soumettrait "0 a 39.90" (la plage entiere) comme si
           c'etait un choix explicite a chaque clic sur "Appliquer", meme
           quand l'utilisateur n'a jamais touche au prix. */
        function updateUI(syncInputs) {
          var minPercent = valueToPercent(minValue);
          var maxPercent = valueToPercent(maxValue);

          minHandle.style.left = minPercent + '%';
          minHandle.style.right = 'auto';

          maxHandle.style.left = maxPercent + '%';
          maxHandle.style.right = 'auto';

          if (fill) {
            fill.style.left = minPercent + '%';
            fill.style.width = Math.max(0, maxPercent - minPercent) + '%';
          }

          minHandle.setAttribute('aria-valuemin', min);
          minHandle.setAttribute('aria-valuemax', max);
          minHandle.setAttribute('aria-valuenow', minValue);
          maxHandle.setAttribute('aria-valuemin', min);
          maxHandle.setAttribute('aria-valuemax', max);
          maxHandle.setAttribute('aria-valuenow', maxValue);

          if (syncInputs) {
            if (minInput) minInput.value = minValue;
            if (maxInput) maxInput.value = maxValue;
          }
        }

        function setMinValue(value) {
          minValue = Math.max(min, Math.min(value, maxValue));
        }

        function setMaxValue(value) {
          maxValue = Math.min(max, Math.max(value, minValue));
        }

        function startDrag(onMove) {
          function handlePointerMove(e) {
            var rect = track.getBoundingClientRect();
            var percent = ((e.clientX - rect.left) / rect.width) * 100;
            var clampedPercent = Math.min(100, Math.max(0, percent));
            onMove(percentToValue(clampedPercent));
            updateUI(true);
          }
          function handlePointerUp() {
            document.removeEventListener('pointermove', handlePointerMove);
            document.removeEventListener('pointerup', handlePointerUp);
            if (applyFiltersDebounced) applyFiltersDebounced();
          }
          document.addEventListener('pointermove', handlePointerMove);
          document.addEventListener('pointerup', handlePointerUp);
        }

        minHandle.addEventListener('pointerdown', function (e) {
          e.preventDefault();
          startDrag(setMinValue);
        });
        maxHandle.addEventListener('pointerdown', function (e) {
          e.preventDefault();
          startDrag(setMaxValue);
        });

        [minHandle, maxHandle].forEach(function (handle) {
          handle.setAttribute('tabindex', '0');
          handle.setAttribute('role', 'slider');
          handle.setAttribute('aria-valuemin', min);
          handle.setAttribute('aria-valuemax', max);

          handle.addEventListener('keydown', function (e) {
            var isMin = handle === minHandle;
            var current = isMin ? minValue : maxValue;
            var next = current;

            if (e.key === 'ArrowRight' || e.key === 'ArrowUp') next = current + step;
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') next = current - step;
            else if (e.key === 'Home') next = min;
            else if (e.key === 'End') next = max;
            else return;

            e.preventDefault();
            if (isMin) setMinValue(next); else setMaxValue(next);
            updateUI(true);
            if (applyFiltersDebounced) applyFiltersDebounced();
          });
        });

        if (minInput) {
          minInput.addEventListener('change', function () {
            var value = parseFloat(minInput.value);
            if (!isNaN(value)) setMinValue(value);
            updateUI(true);
            if (applyFiltersDebounced) applyFiltersDebounced();
          });
        }
        if (maxInput) {
          maxInput.addEventListener('change', function () {
            var value = parseFloat(maxInput.value);
            if (!isNaN(value)) setMaxValue(value);
            updateUI(true);
            if (applyFiltersDebounced) applyFiltersDebounced();
          });
        }

        updateUI(false);
      });
    }

    /* Accordeons "Prix"/"Gout"/etc. du tiroir de filtres — meme logique que
       le script Webflow d'origine (aria-expanded, id genere), rappelee a
       chaque fetch pour la meme raison que initPriceSliders. */
    function initFilterAccordions(scope) {
      scope.querySelectorAll('.product_filters-accordion').forEach(function (accordion, index) {
        var trigger = accordion.querySelector('[data-filter-trigger]');
        var body = accordion.querySelector('[data-filter-body]');
        if (!trigger) return;

        var triggerId = 'filter-trigger-' + root.getAttribute('data-section-id') + '-' + index;
        var bodyId = 'filter-body-' + root.getAttribute('data-section-id') + '-' + index;

        trigger.id = triggerId;
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('aria-expanded', body ? body.classList.contains('is-open') : false);

        if (body) {
          body.id = bodyId;
          trigger.setAttribute('aria-controls', bodyId);
        }

        function toggle() {
          var isOpen = body ? body.classList.toggle('is-open') : false;
          trigger.classList.toggle('is-open', isOpen);
          trigger.setAttribute('aria-expanded', isOpen);
        }

        trigger.addEventListener('click', toggle);
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
      });
    }

    /* Ouverture/fermeture du tiroir de filtres via window.SiteOverlay.
       {% javascript %} est charge en defer, potentiellement avant le
       DOMContentLoaded de utility_scripts.liquid qui pose SiteOverlay — on
       retente jusqu'a ce qu'il existe. */
    function initFilterDrawer() {
      if (!window.SiteOverlay) {
        setTimeout(initFilterDrawer, 50);
        return;
      }
      var filterTrigger = document.querySelector('[data-filter-open]');
      var filterDrawer = document.querySelector('[data-filter-drawer]');
      var filterClose = document.querySelector('[data-filter-close]');
      if (!filterDrawer) return;

      function openFilters() {
        filterDrawer.classList.add('is-open');
        window.SiteOverlay.open('filter');
        window.SiteOverlay.lockScroll();
      }
      function closeFilters() {
        filterDrawer.classList.remove('is-open');
        window.SiteOverlay.close();
        window.SiteOverlay.unlockScroll();
      }
      window.SiteOverlay.registerClose('filter', closeFilters);
      if (filterTrigger) filterTrigger.addEventListener('click', openFilters);
      if (filterClose) filterClose.addEventListener('click', closeFilters);
    }

    function buildQuery() {
      var form = root.querySelector('[data-filters-form]');
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (key) {
        if (params.get(key) === '') params.delete(key);
      });
      return params.toString();
    }

    /* Reconciliation par produit (meme technique que le theme Shopify
       Horizon, voir assets/facets.js + assets/utilities.js du repo
       Shopify/horizon) : au lieu de jeter/recreer toutes les cartes, on
       reutilise le noeud DOM des produits presents avant ET apres le
       filtrage (matches par data-product-id). Un meme noeud DOM qui change
       juste de position dans la grille est ce dont la View Transitions API
       a besoin pour animer un "glissement" vers la nouvelle place plutot
       qu'un saut sec — voir startGridTransition plus bas. */
    function reconcileGrid(oldGrid, newGrid) {
      var oldById = {};
      Array.from(oldGrid.children).forEach(function (item) {
        var id = item.getAttribute('data-product-id');
        if (id) oldById[id] = item;
      });

      Array.from(newGrid.children).forEach(function (freshItem) {
        var id = freshItem.getAttribute('data-product-id');
        var reused = id && oldById[id];
        if (reused) {
          /* Meme noeud DOM reutilise (identite/position preservee pour la
             transition), mais contenu rafraichi (prix, badges, image...). */
          reused.innerHTML = freshItem.innerHTML;
          oldGrid.appendChild(reused);
          delete oldById[id];
        } else {
          /* Produit qui n'etait pas affiche avant (nouveau dans les
             resultats) : pas de noeud a reutiliser, on deplace le nouveau. */
          oldGrid.appendChild(freshItem);
        }
      });

      /* Ce qui reste dans oldById n'est plus dans les resultats filtres. */
      Object.keys(oldById).forEach(function (id) { oldById[id].remove(); });
    }

    /* Enveloppe applyDom() dans document.startViewTransition() : les cartes
       encore presentes avant/apres (meme noeud DOM grace a reconcileGrid)
       recoivent un view-transition-name le temps de la transition, ce qui
       suffit a l'API native du navigateur pour animer leur repositionnement
       tout seule (glissement, ~0.25s, sans CSS custom a ecrire). Repli
       silencieux sur un rendu instantane si l'API n'est pas supportee, si
       l'utilisateur a demande moins d'animations, ou si une transition est
       deja en cours (le navigateur rejette startViewTransition() dans ce
       cas — plusieurs filtres/tris déclenchés coup sur coup, ex. changement
       de tri suivi d'un clic filtre avant la fin de l'animation).

       Si le tiroir de filtres est ouvert, le pseudo-arbre ::view-transition
       du navigateur (qui se peint dans un calque au-dessus de tout le
       document, comme ::backdrop/<dialog>) ferait sinon passer les cartes
       animees au-dessus du tiroir et de son overlay, quel que soit leur
       z-index normal — aucun z-index de document ne peut rattraper ce
       calque. Plutot que de desactiver l'animation dans ce cas, le tiroir
       et l'overlay recoivent eux aussi un view-transition-name : ils
       entrent alors dans le meme calque que les cartes, ou un z-index plus
       eleve (voir ::view-transition-group(filter-drawer)/(filter-overlay)
       dans le stylesheet plus bas) les garde au-dessus. */
    var activeGridTransition = null;

    function startGridTransition(applyDom, drawerIsOpen) {
      var supportsViewTransition = typeof document.startViewTransition === 'function';
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!supportsViewTransition || reducedMotion || activeGridTransition) {
        applyDom();
        return;
      }

      var cardsBefore = Array.from(root.querySelectorAll('.products_list-item[data-product-id]'));
      cardsBefore.forEach(function (card) {
        card.style.setProperty('view-transition-name', 'product-card-' + card.getAttribute('data-product-id'));
      });

      /* L'overlay partage (SiteOverlay) vit hors de #ProductsListComponent-*
         donc n'est jamais recree par le innerHTML swap — un seul tag suffit.
         Le tiroir, lui, EST recree par le swap : applyDom() re-tague le
         nouveau noeud juste apres (voir plus bas, meme nom pour que le
         navigateur les associe old/new malgre le changement de noeud). */
      var overlayEl = drawerIsOpen ? document.querySelector('[data-dropdown-overlay]') : null;
      if (drawerIsOpen) {
        var drawerBefore = document.querySelector('[data-filter-drawer]');
        if (drawerBefore) drawerBefore.style.setProperty('view-transition-name', 'filter-drawer');
      }
      if (overlayEl) overlayEl.style.setProperty('view-transition-name', 'filter-overlay');

      var transition = document.startViewTransition(applyDom);
      activeGridTransition = transition;
      /* .ready peut etre rejetee independamment de .finished (ex. onglet
         non visible au moment de l'appel) — sans ce .catch(), le rejet
         remonte comme une exception "Uncaught (in promise)" non liee au
         .catch() pose plus bas sur .finished. */
      transition.ready.catch(function () {});
      transition.finished
        .catch(function () {
          /* Transition annulee/avortee par le navigateur (ex. interaction
             utilisateur pendant l'animation, onglet non visible) : applyDom()
             a deja tourne via le callback, rien a refaire ici — seul le
             nettoyage compte. */
        })
        .finally(function () {
          activeGridTransition = null;
          root.querySelectorAll('.products_list-item[data-product-id]').forEach(function (card) {
            card.style.removeProperty('view-transition-name');
          });
          var drawerAfter = document.querySelector('[data-filter-drawer]');
          if (drawerAfter) drawerAfter.style.removeProperty('view-transition-name');
          if (overlayEl) overlayEl.style.removeProperty('view-transition-name');
        });
    }

    /* Remplace uniquement le contenu de #ProductsListComponent-* (filtres +
       grille) — le formulaire est recree a chaque fois avec l'etat/les
       compteurs renvoyes par le serveur. Les widgets (slider, accordeons,
       tiroir) sont rebranches sur le nouveau contenu juste apres, puisque
       leurs ecouteurs sont directement sur les elements remplaces. */
    function fetchAndRender(fetchUrl, pushUrl) {
      fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          /* Le HTML renvoye par le serveur ne connait jamais l'etat "ouvert"
             du tiroir/des accordeons (classes is-open posees cote client) :
             sans ca, chaque filtrage (y compris relacher le handle du prix,
             qui en declenche un) referme tout d'un coup en remplacant le
             contenu. On lit l'etat ici (pas avant le fetch) : s'il a ete
             ferme explicitement entre-temps (bouton "Appliquer"), ce sont
             ces lignes-la, executees en synchrone avant que la reponse
             n'arrive, qui font foi — pas un etat capture trop tot. */
          var drawerWasOpen = !!document.querySelector('[data-filter-drawer].is-open');
          var openAccordionIndexes = Array.from(root.querySelectorAll('.product_filters-accordion')).reduce(function (acc, accordion, index) {
            var header = accordion.querySelector('.product_filters-header');
            if (header && header.classList.contains('is-open')) acc.push(index);
            return acc;
          }, []);

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(contentId);
          var current = document.getElementById(contentId);
          if (!fresh || !current) return;

          function applyDom() {
            var oldGrid = current.querySelector('.products_list');
            current.innerHTML = fresh.innerHTML;
            var newGrid = current.querySelector('.products_list');
            if (oldGrid && newGrid) {
              reconcileGrid(oldGrid, newGrid);
              newGrid.replaceWith(oldGrid);
            }
            if (drawerWasOpen) {
              var drawer = current.querySelector('[data-filter-drawer]');
              if (drawer) {
                drawer.classList.add('is-open');
                /* Meme view-transition-name que l'ancien noeud (detruit par
                   le innerHTML swap juste au-dessus) : le navigateur associe
                   les deux par nom, pas par identite de noeud — voir
                   startGridTransition. */
                drawer.style.setProperty('view-transition-name', 'filter-drawer');
              }
            }
            Array.from(current.querySelectorAll('.product_filters-accordion')).forEach(function (accordion, index) {
              if (openAccordionIndexes.indexOf(index) === -1) return;
              var header = accordion.querySelector('.product_filters-header');
              var body = accordion.querySelector('.product_filters-body');
              if (header) header.classList.add('is-open');
              if (body) body.classList.add('is-open');
            });
            initPriceSliders(current);
            initFilterAccordions(current);
            initFilterDrawer();
            if (window.ALDataLayer) window.ALDataLayer.scanItems(current);
            if (typeof window.initScrollReveal === 'function') window.initScrollReveal(document);
          }

          startGridTransition(applyDom, drawerWasOpen);
          if (pushUrl !== null) history.pushState({}, '', pushUrl);
        })
        .catch(function (err) {
          console.error('[filtres] echec du filtrage', err);
        });
    }

    /* "Charger plus de produits" : ajoute uniquement les nouveaux produits a
       la grille existante (pattern load-more, pas une pagination classique)
       -- meme technique que sections/liste_articles.liquid. Contrairement a
       fetchAndRender (filtres/tri), pas de startGridTransition ici : rien
       n'est reordonne/retire, on ne fait qu'ajouter a la fin. */
    function fetchAndAppend(fetchUrl, loadMoreLink) {
      if (isLoadingMore) return;
      isLoadingMore = true;
      loadMoreLink.classList.add('is-loading');
      fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshList = doc.querySelector('#' + contentId + ' .products_list');
          var currentList = document.querySelector('#' + contentId + ' .products_list');
          if (freshList && currentList) {
            Array.from(freshList.children).forEach(function (item) {
              item.classList.add('is-appearing');
              currentList.appendChild(item);
            });
            requestAnimationFrame(function () {
              Array.from(currentList.querySelectorAll('.is-appearing')).forEach(function (item) {
                item.classList.remove('is-appearing');
              });
            });
            if (window.ALDataLayer) window.ALDataLayer.scanItems(currentList);
            /* Meme correctif que sections/liste_articles.liquid : sans reobservation,
               les produits ajoutes restent figes a opacity:0 (animation jamais jouee). */
            if (typeof window.initScrollReveal === 'function') window.initScrollReveal(document);
          }
          var freshPagination = doc.querySelector('#' + contentId + ' [data-pagination-wrapper]');
          var currentPagination = document.querySelector('#' + contentId + ' [data-pagination-wrapper]');
          if (currentPagination) {
            if (freshPagination) {
              currentPagination.replaceWith(freshPagination);
            } else {
              currentPagination.remove();
            }
          }
        })
        .catch(function (err) {
          console.error('[produits] echec du chargement', err);
        })
        .finally(function () {
          isLoadingMore = false;
        });
    }

    function applyFilters() {
      var query = buildQuery();
      var pushUrl = collectionUrl + (query ? '?' + query : '');
      var fetchUrl = collectionUrl + '?' + query + (query ? '&' : '') + 'section_id=' + SECTION_ID;
      if (window.ALDataLayer) {
        window.ALDataLayer.event('filter_applied', {
          filter_query: query,
          collection_id: collectionId,
          collection_name: collectionTitle
        });
      }
      fetchAndRender(fetchUrl, pushUrl);
    }

    applyFiltersDebounced = debounce(applyFilters, 300);

    /* Tri et cases a cocher (disponibilite, listes) : ecoute deleguee car
       elles n'ont pas de comportement propre a rebrancher, contrairement
       aux widgets ci-dessus — seul le sourcing de la requete de filtrage
       nous interesse ici. Les champs de prix ont deja leur propre 'change'
       pose par initPriceSliders, on les exclut pour ne pas doubler l'appel. */
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-range-input]')) return;
      if (e.target.matches('[data-filter-input]')) {
        var toggle = e.target.closest('.product_filters-toggle');
        if (toggle) toggle.classList.toggle('is-checked', e.target.checked);
        applyFilters();
      } else if (e.target.id === 'sort-by') {
        applyFilters();
      }
    });

    /* "Charger plus" et bouton "Appliquer" : partie du moteur AJAX, pas des
       widgets repris du script Webflow — restent en delegation. */
    root.addEventListener('click', function (e) {
      var loadMoreLink = e.target.closest('[data-load-more]');
      if (loadMoreLink) {
        e.preventDefault();
        var nextUrl = new URL(loadMoreLink.href, window.location.origin);
        nextUrl.searchParams.set('section_id', SECTION_ID);
        fetchAndAppend(nextUrl.toString(), loadMoreLink);
        return;
      }

      if (e.target.closest('[data-filters-button]')) {
        applyFilters();
        var drawerToClose = document.querySelector('[data-filter-drawer]');
        if (drawerToClose) drawerToClose.classList.remove('is-open');
        if (window.SiteOverlay) {
          window.SiteOverlay.close();
          window.SiteOverlay.unlockScroll();
        }
        return;
      }
    });

    window.addEventListener('popstate', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('section_id', SECTION_ID);
      fetchAndRender(url.toString(), null);
    });

    initPriceSliders(root);
    initFilterAccordions(root);
    initFilterDrawer();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resultats_recherche"] && !Shopify.designMode) return;
  try {
    
  /* « Charger plus » : on recharge cette section seule et on ajoute les
     nouvelles cartes a la suite, sans recharger la page. Meme principe que
     produits_filtres.liquid, en version reduite — ici il n'y a ni filtres ni
     tri a resynchroniser. */
  (function () {
    var SECTION_ID = 'resultats_recherche';

    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;
      var lien = e.target.closest('[data-load-more]');
      if (!lien) return;

      var liste = lien.closest('[data-recherche-liste]');
      if (!liste) return;

      e.preventDefault();
      if (lien.hasAttribute('aria-busy')) return;
      lien.setAttribute('aria-busy', 'true');

      var url = new URL(lien.href, window.location.origin);
      url.searchParams.set('section_id', SECTION_ID);

      fetch(url.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nouvelles = doc.querySelector('.products_list');
          var cible = liste.querySelector('.products_list');
          var ajoutees = [];
          if (nouvelles && cible) {
            while (nouvelles.firstElementChild) {
              var carte = nouvelles.firstElementChild;
              ajoutees.push(carte);
              cible.appendChild(carte);
            }
          }

          /* Le bouton suivant remplace le precedent, ou disparait s'il n'y a
             plus de page. */
          var pagination = liste.querySelector('[data-pagination-wrapper]');
          var nouvellePagination = doc.querySelector('[data-pagination-wrapper]');
          if (pagination) {
            if (nouvellePagination) {
              pagination.replaceWith(nouvellePagination);
            } else {
              pagination.remove();
            }
          }

          /* Revelation directe des cartes ajoutees, sans passer par
             l'IntersectionObserver du theme.

             La regle CSS est [data-animate-stagger] > * { opacity: 0 }, levee
             par .is-inview. L'observateur ne pose cette classe que s'il voit
             l'element ENTRER dans l'ecran. Or ces cartes arrivent au clic, au
             ras du bas de l'ecran : selon la position de la page elles
             naissent deja a moitie visibles, ou sont depassees d'un seul geste
             de defilement, et l'entree n'est jamais observee — elles restaient
             alors invisibles pour de bon.

             Ici il n'y a rien a attendre : le visiteur a demande ces produits,
             on les montre. L'index de stagger est repose depuis 0 pour que la
             cascade se joue sur ce lot et pas depuis le debut de la liste.

             Volontairement synchrone, sans requestAnimationFrame : celui-ci ne
             se declenche pas tant que la page n'est pas peinte. Un visiteur qui
             clique puis change d'onglet, ou dont le navigateur met la page en
             veille, ne verrait jamais les cartes apparaitre. La lecture de
             offsetHeight force le calcul de l'etat initial (opacity 0) avant le
             changement de classe, ce qui suffit a jouer la transition. */
          ajoutees.forEach(function (carte, i) {
            carte.style.setProperty('--stagger-index', i);
          });
          void cible.offsetHeight;
          ajoutees.forEach(function (carte) {
            carte.classList.add('is-inview');
          });

          /* Les cartes ajoutees doivent aussi etre reprises par la collecte GA4. */
          if (window.ALDataLayer) window.ALDataLayer.scanItems(cible);
        })
        .catch(function () {
          lien.removeAttribute('aria-busy');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider_ambassadeurs"] && !Shopify.designMode) return;
  try {
    
  /* Popup ambassadeur : ouvre le composant [data-ambassadeur-id] correspondant
     au trigger clique, masque les autres, verrouille le scroll. Ferme au clic
     sur l'overlay ou le bouton de fermeture. Scope a cette section : ce JS
     n'est charge que sur les pages qui ont reellement ce slider.

     .ambassadeurs_pop-overlay et .ambassadeurs_pop-component partent tous
     les deux de display:none en CSS, avec la transition (fondu + glissement,
     et depuis le bas sur mobile) posee sur la meme regle .is-open qui bascule
     aussi le display. display:none -> flex etant instantane, la transition
     n'avait jamais de position de depart reelle a partir de laquelle animer :
     l'ouverture/fermeture semblait brute. On bascule le display explicitement
     en JS d'abord (etat ferme peint), puis .is-open une frame plus tard pour
     que le fondu/glissement ait un vrai etat de depart. A la fermeture, on
     attend la fin de la transition CSS avant de repasser en display:none. */
  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.querySelector('[data-ambassadeur-overlay]');
    if (!overlay) return;

    var CLOSE_DELAY = 400; // calee sur la transition .4s de .ambassadeurs_pop-component

    function lockScroll() {
      document.body.classList.add('no-scroll');
    }

    function unlockScroll() {
      document.body.classList.remove('no-scroll');
    }

    function openPop(id) {
      var target = overlay.querySelector('[data-ambassadeur-id="' + id + '"]');
      if (!target) return;

      overlay.querySelectorAll('[data-ambassadeur-id]').forEach(function (el) {
        el.classList.remove('is-open');
        el.style.display = 'none';
      });

      overlay.style.display = 'flex';
      target.style.display = 'flex';
      overlay.offsetHeight; // force le reflow avant de declencher la transition
      overlay.classList.add('is-open');
      target.classList.add('is-open');

      lockScroll();
    }

    function closePop() {
      var openTarget = overlay.querySelector('[data-ambassadeur-id].is-open');
      overlay.classList.remove('is-open');
      if (openTarget) openTarget.classList.remove('is-open');

      setTimeout(function () {
        overlay.style.display = 'none';
        if (openTarget) openTarget.style.display = 'none';
      }, CLOSE_DELAY);

      unlockScroll();
    }

    document.querySelectorAll('[data-ambassadeur-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openPop(trigger.getAttribute('data-ambassadeur-open'));
      });
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePop();
      if (e.target.closest('[data-ambassadeur-close]')) closePop();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider_produits"] && !Shopify.designMode) return;
  try {
    
  function initRecommendationsSlider() {
    var host = document.querySelector('[data-recommendations-host]');
    if (!host) return;
    var sectionId = host.getAttribute('data-section-id');
    var productId = host.getAttribute('data-product-id');
    if (!sectionId || !productId) return;
    var limit = host.getAttribute('data-recommendations-limit') || 8;
    var intent = host.getAttribute('data-recommendations-intent') || 'related';

    function load() {
      fetch('/recommendations/products?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit + '&intent=' + intent)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.product-recommendations');
          if (!fresh || !fresh.innerHTML.trim()) return;
          host.innerHTML = fresh.innerHTML;
          host.querySelectorAll('.embla').forEach(function (el) {
            if (typeof window.initEmbla === 'function') window.initEmbla(el);
          });
          if (typeof window.initScrollReveal === 'function') window.initScrollReveal(host);
          if (window.ALDataLayer) window.ALDataLayer.scanItems(host);
        })
        .catch(function () {});
    }

    /* Chargement differe jusqu'a ce que le bloc entre dans le viewport
       (pattern recommande par Shopify) : evite de consommer l'appel
       recommandations pour les visiteurs qui ne scrollent jamais jusque-la. */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(host);
        load();
      }, { rootMargin: '0px 0px 200px 0px' });
      observer.observe(host);
    } else {
      load();
    }
  }

  /* Ce script (comme tout {% javascript %} de section) est charge via le
     bundle compile_assets/scripts.js, dont l'execution peut intervenir
     APRES que DOMContentLoaded ait deja ete emis pour la page -- un
     addEventListener pose a ce moment-la n'aurait jamais declenche le
     callback (l'evenement ne "rejoue" pas). On verifie donc l'etat actuel
     du document avant de choisir d'ecouter ou d'executer immediatement. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecommendationsSlider);
  } else {
    initRecommendationsSlider();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider_produits_obje"] && !Shopify.designMode) return;
  try {
    
  /* Bulle de conseil "Nos experts vous conseillent" : simple fermeture au
     clic, pas de memorisation (contrairement au bloc Conseils des heros
     Famille/Categorie). Scope a cette section : ce JS n'est charge que sur
     les pages qui ont reellement cette bulle. */
  /* Mobile (<= 767px) : la bulle est reduite a une pastille "?" et son
     contenu ne s'affiche qu'avec .is-visible (CSS) -- rien ne l'ajoutait,
     le "?" etait donc inerte. Toucher le "?" bascule le conseil, le bouton
     "-" ou un toucher ailleurs le referme, la pastille reste en place.
     Desktop : la bulle est affichee en entier, "-" la retire comme avant. */
  document.addEventListener('DOMContentLoaded', function () {
    var mobile = window.matchMedia('(max-width: 767px)');
    document.querySelectorAll('[data-objectifs-tip-wrapper]').forEach(function (wrapper) {
      var content = wrapper.querySelector('.objectifs_conseils-content');
      var closeBtn = wrapper.querySelector('[data-objectifs-tip-close]');
      wrapper.style.cursor = 'pointer';
      wrapper.addEventListener('click', function (e) {
        if (!mobile.matches || !content) return;
        if (closeBtn && closeBtn.contains(e.target)) return;
        if (content.contains(e.target)) return;
        document.querySelectorAll('.objectifs_conseils-content.is-visible').forEach(function (other) {
          if (other !== content) other.classList.remove('is-visible');
        });
        content.classList.toggle('is-visible');
      });
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (mobile.matches && content) content.classList.remove('is-visible');
          else wrapper.remove();
        });
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-objectifs-tip-wrapper]')) return;
      document.querySelectorAll('.objectifs_conseils-content.is-visible').forEach(function (c) { c.classList.remove('is-visible'); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  /* Onglets a rotation automatique : chaque onglet reste actif le temps
     configure (data-tab-duration), pendant lequel sa barre de progression
     s'anime de 0 a 100%. Un clic sur un onglet le rend actif immediatement
     et relance le cycle depuis celui-ci. Scope a cette section plutot que
     dans utility_scripts.liquid : ce JS n'est alors charge que sur les
     pages qui ont reellement des tabs. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tabs-component]').forEach(function (component) {
      var links = Array.prototype.slice.call(component.querySelectorAll('[data-tab-link]'));
      var panels = Array.prototype.slice.call(component.querySelectorAll('[data-tab-panel]'));
      if (!links.length) return;
      var durationSeconds = parseFloat(component.getAttribute('data-tab-duration')) || 6;
      var current = 0;
      var autoTimeout;

      function show(index) {
        current = index;
        links.forEach(function (link, i) {
          var isActive = i === index;
          link.classList.toggle('is-active', isActive);
          var progress = link.querySelector('[data-tab-progress]');
          if (progress) {
            progress.style.transition = 'none';
            progress.style.width = '0%';
            progress.offsetWidth; // force le reflow avant de reactiver la transition
            if (isActive) {
              progress.style.transition = 'width ' + durationSeconds + 's linear';
              progress.style.width = '100%';
            } else {
              progress.style.transition = '';
            }
          }
        });
        panels.forEach(function (panel, i) {
          panel.classList.toggle('is-active', i === index);
        });
      }

      function scheduleNext() {
        clearTimeout(autoTimeout);
        if (links.length < 2) return;
        autoTimeout = setTimeout(function () {
          show((current + 1) % links.length);
          scheduleNext();
        }, durationSeconds * 1000);
      }

      links.forEach(function (link, index) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          show(index);
          scheduleNext();
        });
      });

      show(0);
      scheduleNext();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs_produit_lp"] && !Shopify.designMode) return;
  try {
    
  /* Meme mecanique de rotation automatique que sections/tabs.liquid (voir ce
     fichier pour le detail) -- dupliquee ici plutot que partagee car les
     deux sections ont des marquages/classes differents (grille de
     comparaison 2x2 ici, texte simple sur tabs.liquid). */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tabs-component]').forEach(function (component) {
      var links = Array.prototype.slice.call(component.querySelectorAll('[data-tab-link]'));
      var panels = Array.prototype.slice.call(component.querySelectorAll('[data-tab-panel]'));
      if (!links.length) return;
      var durationSeconds = parseFloat(component.getAttribute('data-tab-duration')) || 6;
      var current = 0;
      var autoTimeout;

      function show(index) {
        current = index;
        links.forEach(function (link, i) {
          var isActive = i === index;
          link.classList.toggle('is-active', isActive);
          var progress = link.querySelector('[data-tab-progress]');
          if (progress) {
            progress.style.transition = 'none';
            progress.style.width = '0%';
            progress.offsetWidth;
            if (isActive) {
              progress.style.transition = 'width ' + durationSeconds + 's linear';
              progress.style.width = '100%';
            } else {
              progress.style.transition = '';
            }
          }
        });
        panels.forEach(function (panel, i) {
          panel.classList.toggle('is-active', i === index);
        });
      }

      function scheduleNext() {
        clearTimeout(autoTimeout);
        if (links.length < 2) return;
        autoTimeout = setTimeout(function () {
          show((current + 1) % links.length);
          scheduleNext();
        }, durationSeconds * 1000);
      }

      links.forEach(function (link, index) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          show(index);
          scheduleNext();
        });
      });

      show(0);
      scheduleNext();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs_produit_seo"] && !Shopify.designMode) return;
  try {
    
  /* Contenu generique (memes blocs sur toutes les fiches SEO, pas de
     metachamps produit) : declares directement dans templates/product.seo.json
     -- les modifier a un seul endroit les modifie pour tous les produits.
     Meme mecanique de rotation automatique que sections/tabs.liquid. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tabs-component]').forEach(function (component) {
      var links = Array.prototype.slice.call(component.querySelectorAll('[data-tab-link]'));
      var panels = Array.prototype.slice.call(component.querySelectorAll('[data-tab-panel]'));
      if (!links.length) return;
      var durationSeconds = parseFloat(component.getAttribute('data-tab-duration')) || 6;
      var current = 0;
      var autoTimeout;

      function show(index) {
        current = index;
        links.forEach(function (link, i) {
          var isActive = i === index;
          link.classList.toggle('is-active', isActive);
          var progress = link.querySelector('[data-tab-progress]');
          if (progress) {
            progress.style.transition = 'none';
            progress.style.width = '0%';
            progress.offsetWidth;
            if (isActive) {
              progress.style.transition = 'width ' + durationSeconds + 's linear';
              progress.style.width = '100%';
            } else {
              progress.style.transition = '';
            }
          }
        });
        panels.forEach(function (panel, i) {
          panel.classList.toggle('is-active', i === index);
        });
      }

      function scheduleNext() {
        clearTimeout(autoTimeout);
        if (links.length < 2) return;
        autoTimeout = setTimeout(function () {
          show((current + 1) % links.length);
          scheduleNext();
        }, durationSeconds * 1000);
      }

      links.forEach(function (link, index) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          show(index);
          scheduleNext();
        });
      });

      show(0);
      scheduleNext();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  /* Anime la ligne de progression et les points de la timeline au scroll :
     la ligne se remplit jusqu'a la position declenchee a mi-hauteur de
     l'ecran, et chaque point s'active des qu'il passe ce seuil. Scope a
     cette section : ce JS n'est charge que sur les pages qui ont
     reellement une timeline. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-timeline]').forEach(function (wrapper) {
      var fill = wrapper.querySelector('[data-timeline-fill]');
      var dots = wrapper.querySelectorAll('[data-timeline-dot]');
      if (!fill) return;

      var TRIGGER_RATIO = 0.5;
      var ticking = false;

      function update() {
        var rect = wrapper.getBoundingClientRect();
        var triggerY = window.innerHeight * TRIGGER_RATIO;
        var scrolled = triggerY - rect.top;
        var progress = Math.min(1, Math.max(0, scrolled / rect.height));

        fill.style.height = (progress * 100) + '%';

        dots.forEach(function (dot) {
          var dotRect = dot.getBoundingClientRect();
          dot.classList.toggle('is-active', dotRect.top <= triggerY);
        });

        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll);
      window.addEventListener('resize', onScroll);
      update();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline_2"] && !Shopify.designMode) return;
  try {
    
  /* Anime la ligne de progression et les points de la timeline au scroll :
     la ligne se remplit jusqu'a la position declenchee a mi-hauteur de
     l'ecran, et chaque point s'active des qu'il passe ce seuil. Scope a
     cette section : ce JS n'est charge que sur les pages qui ont
     reellement une timeline. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-timeline]').forEach(function (wrapper) {
      var fill = wrapper.querySelector('[data-timeline-fill]');
      var dots = wrapper.querySelectorAll('[data-timeline-dot]');
      if (!fill) return;

      var TRIGGER_RATIO = 0.5;
      var ticking = false;

      function update() {
        var rect = wrapper.getBoundingClientRect();
        var triggerY = window.innerHeight * TRIGGER_RATIO;
        var scrolled = triggerY - rect.top;
        var progress = Math.min(1, Math.max(0, scrolled / rect.height));

        fill.style.height = (progress * 100) + '%';

        dots.forEach(function (dot) {
          var dotRect = dot.getBoundingClientRect();
          dot.classList.toggle('is-active', dotRect.top <= triggerY);
        });

        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll);
      window.addEventListener('resize', onScroll);
      update();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
